import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { CommonDeleteButton, CommonEditButton, CommonPatientCard, CommonPatientDetails, ConfirmPopup } from '../../../../../Components/Common Components/CommonComponents';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../../../../Utility/Services/CacheProviderService';
import {
    Box, Button, TextField, Tooltip, TableContainer, Table, TableHead, TableRow,
    TableCell, TableBody, Autocomplete, Typography, IconButton, FormControlLabel, Radio, Dialog, RadioGroup,
    Grid,
    FormHelperText,
    Popover,
    Divider
} from '@mui/material';
import Loader from '../../../../../Components/Loader';
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../../Styles/Colors';
import CommonValidation from '../../../../../Components/CommonFunctions/CommonValidation';
import { ImagePaths } from '../../../../../Utility/ImagePaths';
import RestAPIService from '../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../Utility/API/Serviceurls';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import Popper from '@mui/material/Popper';
import { CheckAccessFunc, AmountFormat } from '../../../../../Components/CommonFunctions/CommonFunctions';
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../../Utility/Constants';
import LineItemRemarksButton from '../../../../../Components/Common Components/LineItemRemarksButton';
import { isLineItemRemarksEnabled, clampLineItemRemarks, isMandatoryConcessionRemarksEnabled } from '../../../../../Utility/lineItemRemarksUtils';

const CustomPopper = (props) => {
    return <Popper {...props} placement="top-start" />;
};

const COMMON_STYLES = {
    HEIGHT: '4.5dvh',
    FONT_SIZE_XS: '0.7rem',
    FONT_SIZE_SM: '0.8rem',
    FONT_SIZE_MD: '0.85rem',
    FONT_SIZE_L: '0.9rem',
    FONT_WEIGHT: 600
}

let userAccess = null;

const CreateOrder = ({ opOrder }) => {
    const history = useHistory();
    const loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    const isOPBilling = JSON.parse(localGetItem('enable_billing_access'))
    const [conditionData, setConditionData] = useState({})
    const AmountViewAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.show_order_amounts) || (loggedInUserInfo?.is_doctor))
    const AmountEditAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.edit_order_amounts) || (loggedInUserInfo?.is_doctor))
    const ConcessionAccess = ((!loggedInUserInfo?.is_user && loggedInUserInfo?.is_doctor == false) || (loggedInUserInfo?.permission_access?.common?.allow_concession) || (loggedInUserInfo?.is_doctor))
    const showPaymentStatusColumn = loggedInUserInfo?.permission_access?.common?.restrict_payment_status !== true
    const [formState, setformState] = useState({
        patientData: {},
        orderList: [],
        dupOrderList: '[]',
        billDocSugg: [],
        serviceSugg: [],
        tempPackSugg: [],
        selected_bill_doc: null,
        consultant_doc: null,
        selected_service: null,
        selected_temp_pack: null,
        selected_corporate_data: null,
        corporatesugg: [],
        employeerID: '',
        service_data: {
            rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
            doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
            hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
            interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
            service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
            edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
            end_time: '', doc_discount_amt: '', doc_discount_percent: '',
            hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
            concession_percent: '', gst_percent: 0, hours: '', minutes: '',
            concession_comments: '', service_details_id: '', doctor_id: '',
            review_days: '', review_count: '', charge_id: '',
            gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
            taxable_amount: '', sub_total_amount: '', round_off: '',
            received_amount: '', net_amount: '', concession_percent_w_r: '',
            doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
            doctor_percent_w_r: '', hospital_percent_w_r: '',
            module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
            service_head_id: null, doctor_id: '', op_order_number: '',
            id: null
        },
        isEdit: false,
        selectedIndex: null,
        fromOrderSummary: false,
        wardList: [],
        selectedward: null,
        openDeletePopup: false, deleted_service: null, deleted_service_index: null, cancel_reason: '', deleted_data: null,
        is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
        deleted_data: null, surgeryId: null
    });
    const [loginInfo, setLoginInfo] = useState(loggedInUserInfo)
    const [selectedRadio, setSelectedRadio] = useState('input')
    const [popupValues, setPopupValues] = useState({})
    const [openPopup, setOpenPopup] = useState(false)
    const [concessionRemarksOpen, setConcessionRemarksOpen] = useState(false)
    const [disableBtn, setDisableBtn] = useState(false)
    const [isLoader, setIsLoader] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [IsWarning, setIsWarning] = useState(false);
    const [tempDup, settempDup] = useState([]);
    const [duplicateIds, setDuplicateIds] = useState([]);
    const [amtState, setamtState] = useState([])
    const [hasDuplicate, setHasDuplicate] = useState(false)
    const [searchKey, setsearchKey] = useState('')
    const [ServiceCount, setServiceCount] = useState(false)
    const [insuToolOpen, setInsuToolOpen] = useState(false);
    const [InvestigationList, setInvestigationList] = useState([])
    const [serviceDate, setserviceDate] = useState(new Date())
    const [dateOpen, setdateOpen] = useState(false)
    const [DateTimeChanged, setDateTimeChanged] = useState(false)
    const [dupOrdersummary, setdupOrdersummary] = useState([])
    const [orderDate, setorderDate] = useState(null)
    const [annualFeeAlert, setAnnualFeeAlert] = useState(false)
    const [annualFeeList, setAnnualFeeList] = useState([])
    const [membershipDetails, setMembershipDetails] = useState(null)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const billingContainerRef = useRef(null);

    useEffect(() => {
        const fetchDoctorList = async () => {
            try {
                setIsLoader(true);
                const response = await RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME);
                if (response?.data?.status === 'success') {
                    const doctors = response?.data?.data || [];

                    setformState((prev) => ({ ...prev, billDocSugg: doctors }));

                    let PatientData = getCachevalue("IppatientData") || getCachevalue("patientData");
                    if (PatientData) {
                        const parsedPatientData = JSON.parse(PatientData);
                        const matchedDoctor = doctors.find(doc => doc.doctor_id === parsedPatientData?.doctor_id);
                        setformState((prev) => ({
                            ...prev,
                            selected_bill_doc: matchedDoctor || null,
                            consultant_doc: matchedDoctor || null
                        }));
                        if (parsedPatientData) {
                            getTemplateList(parsedPatientData?.appointment_id ? 'op' : parsedPatientData?.id ? 'ip' : 'radiology', parsedPatientData);
                        }
                        if (parsedPatientData?.appointment_id) {
                            getBillingPatientData(parsedPatientData?.appointment_id);
                        }
                        if(!opOrder){
                            getIpAdmissionDetails(parsedPatientData?.id)
                        }
                    }
                }
            } catch (error) {
                setIsLoader(false);
                errorMessage(error?.response?.data?.message || error.message);
            }
        };
        // Hide tooltip after 3 seconds
        const hideTooltip = setTimeout(() => {
            setInsuToolOpen(false);
        }, 3000);
        setInvestigationList(localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : [])
        

        fetchDoctorList();
        userAccess = getCachevalue("patientData")
            ? CheckAccessFunc("front_office", "Home", "Order", "Create Order", "SubTab")
            : CheckAccessFunc("front_office", "In Patients", "Order", "Create Order", "SubTab");

        return () => {
            clearTimeout(hideTooltip);
        };
    }, []);

    useEffect(() => {
        if (DateTimeChanged) return;
        let lastMinute = new Date().getMinutes();
        // Update every minute instead of every second
        const intervalId = setInterval(() => {
            const now = new Date();
            if (now.getMinutes() !== lastMinute) {
                lastMinute = now.getMinutes();
                setserviceDate(now);
            }
        }, 1000);

  return () => clearInterval(intervalId); 
}, [DateTimeChanged]);

    const setAutoBillData = (data = []) => {
        try {
            let newOrderList = []; let surgery_request_id = null
            for (let i = 0; i < data?.length; i++) {
                let element = {}
                if ('emergency' in data[i]) {
                    element = data[i]?.emergency
                } else if ('holiday' in data[i]) {
                    element = data[i]?.holiday
                } else {
                    element = data[i]
                }
                if (data[i]?.surgery_request_id) {
                    surgery_request_id = data[i]?.surgery_request_id
                }
                let packageLine = element?.package_line
                if (data[i]?.package_type === 'Assorted' || data[i]?.package_type === 'Package') {
                    for (let k = 0; k < packageLine?.length; k++) {
                        const pack = packageLine[k]
                        let total_with_discount = pack?.total_amount ? pack?.total_amount : pack?.service_charge ? pack?.service_charge : pack?.total_amount;
                        let totalAmt = pack?.sub_total_amount ? pack?.sub_total_amount : pack?.service_charge ? pack?.service_charge : pack?.sub_total_amount;
                        newOrderList?.push({
                            rate_per_unit: pack.service_charge,
                            unit: pack.unit,
                            unit_type: pack.unit_type,
                            total_amt: totalAmt || 0,
                            total_with_discount: total_with_discount || 0,
                            doctor_amt: pack.doctor_share_amount,
                            doctor_percent: pack.doctor_share_percent,
                            old_doctor_amt: pack.doctor_share_amount,
                            new_doctor_amt: pack.doctor_share_amount,
                            hospital_amt: pack.hospital_share_amount,
                            hospital_percent: pack.hospital_share_percent,
                            old_hospital_amt: pack.hospital_share_amount,
                            new_hospital_amt: pack.hospital_share_amount,
                            interval_time: pack.interval_time,
                            interval_amount: pack.interval_amount,
                            service_name: pack.service_name,
                            service_head_name: pack.service_head,
                            service_code: pack.service_code,
                            service_head_code: pack.service_head_code,
                            edit_unit: pack.edit_unit,
                            edit_amount: pack.edit_amount,
                            edit_discount: pack.edit_discount,
                            doctor_name: (pack.doctor_name || formState?.patientData?.doctor_name),
                            doctor_id: (pack.doctor_id || formState?.patientData?.doctor_id),
                            start_time: pack.start_time,
                            end_time: pack.end_time,
                            gst_percent: pack.gst_percent || 0,
                            hours: pack.unit_type === 'Hrs' ? pack.unit?.toString()?.split(":")[0] : '',
                            minutes: pack.unit_type === 'Hrs' ? pack.unit?.toString()?.split(":")[1] : '',
                            service_details_id: pack?.service_details_id,
                            review_days: pack?.review_days,
                            review_count: pack?.review_count,
                            charge_id: pack?.charge_id,
                            module_type: pack?.module_type,
                            doctor_percent_w_r: +(pack?.doctor_share_percent?.toFixed(2)),
                            hospital_percent_w_r: +(pack?.hospital_share_percent?.toFixed(2)),
                            start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                            end_date: null,
                            is_hospital: pack?.is_hospital,
                            service_head_id: pack?.service_head_id,
                            op_order_number: pack?.op_order_number,
                            old_time_taken: pack.unit_type === 'Hrs' ? pack?.unit : null,
                            doc_discount_amt: '',
                            doc_discount_percent: '',
                            doc_discount_percent_w_r: '',
                            hos_discount_amt: '',
                            hos_discount_percent: '',
                            hos_discount_percent_w_r: '',
                            is_sharable: pack?.is_sharable,
                            is_consultation: pack?.is_consultation,
                            fixed_time: pack.unit_type === 'Hrs' ? pack?.unit : '',
                            drug_config_id: pack?.drug_config_id ?? null,
                            ward_name: (pack?.ward_name || formState?.patientData?.ward_name),
                            ward_id: formState?.patientData?.ward_id ?? null,
                            module_type: pack?.module ?? pack?.module_type ?? '',
                            concession_amt: pack?.discount_amount ?? '',
                            concession_percent: pack?.discount_percentage ?? '',
                            concession_percent_w_r: (+pack?.discount_percentage)?.toFixed(2),
                            billing_display: element?.billing_display ?? '',
                            package_id: element?.package_type === 'Assorted' ? null : pack?.package_detail_id,
                            package_name: element?.package_type === 'Assorted' ? '' : element?.package_name,
                            package_type: element?.package_type === 'Package' ? 'Package' : 'Assorted',
                            package_package_id: element?.package_type === 'Assorted' ? null : pack?.package_id,
                            assorted_id: element?.package_type === 'Assorted' ? pack?.package_detail_id : null,
                            assorted_name: element?.package_type === 'Assorted' ? pack?.package_name : '',
                            assorted_package_id: element?.package_type === 'Assorted' ? pack?.package_id : null,
                            assorted_head_id: element?.package_type === 'Assorted' ? pack?.package_head_id : null,
                            drug_config_id: pack?.drug_config_id ?? null,
                            sub_total_amount: totalAmt ?? 0,
                            drug_ms_id: pack?.drug_ms_id ?? null,
                            pharmacy_id: pack?.pharmacy_id ?? null,
                            sub_location_id: pack?.sub_location_id ?? null,
                        })
                    }
                } else {
                    let total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount;
                    let totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount;

                    // newOrderList?.push({
                    let serviceObj = {
                        rate_per_unit: element.service_charge,
                        unit: element.unit,
                        unit_type: element.unit_type,
                        total_amt: totalAmt || 0,
                        total_with_discount: total_with_discount || 0,
                        doctor_amt: element.doctor_share_amount,
                        doctor_percent: element.doctor_share_percent,
                        old_doctor_amt: element.doctor_share_amount,
                        new_doctor_amt: element.doctor_share_amount,
                        hospital_amt: element.hospital_share_amount,
                        hospital_percent: element.hospital_share_percent,
                        old_hospital_amt: element.hospital_share_amount,
                        new_hospital_amt: element.hospital_share_amount,
                        interval_time: element.interval_time,
                        interval_amount: element.interval_amount,
                        service_name: element.service_name,
                        service_head_name: element.service_head,
                        service_code: element.service_code,
                        service_head_code: element.service_head_code,
                        edit_unit: element.edit_unit,
                        edit_amount: element.edit_amount,
                        edit_discount: element.edit_discount,
                        doctor_name: (element.doctor_name || formState?.patientData?.doctor_name),
                        doctor_id: (element.doctor_id || formState?.patientData?.doctor_id),
                        start_time: element.start_time,
                        end_time: element.end_time,
                        gst_percent: element.gst_percent || 0,
                        hours: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[0] : '',
                        minutes: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[1] : '',
                        service_details_id: element?.service_details_id,
                        review_days: element?.review_days,
                        review_count: element?.review_count,
                        charge_id: element?.charge_id,
                        module_type: element?.module_type,
                        doctor_percent_w_r: +(element?.doctor_share_percent?.toFixed(2)),
                        hospital_percent_w_r: +(element?.hospital_share_percent?.toFixed(2)),
                        start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                        end_date: null,
                        is_hospital: element?.is_hospital,
                        service_head_id: element?.service_head_id,
                        op_order_number: element?.op_order_number,
                        old_time_taken: element.unit_type === 'Hrs' ? element?.unit : null,
                        doc_discount_amt: '',
                        doc_discount_percent: '',
                        doc_discount_percent_w_r: '',
                        hos_discount_amt: '',
                        hos_discount_percent: '',
                        hos_discount_percent_w_r: '',
                        is_sharable: element?.is_sharable,
                        is_consultation: element?.is_consultation,
                        fixed_time: element.unit_type === 'Hrs' ? element?.unit : '',
                        module_type: element?.module ?? element?.module_type ?? '',
                        drug_config_id: element?.drug_config_id ?? null,
                        ward_name: (element?.ward_name || formState?.patientData?.ward_name),
                        ward_id: formState?.patientData?.ward_id ?? null,
                        concession_amt: element?.discount_amount ?? '',
                        concession_percent: element?.discount_percentage ?? '',
                        concession_percent_w_r: (+element?.discount_percentage)?.toFixed(2),
                        billing_display: element?.billing_display ?? '',
                        package_id: element?.package_type === 'Assorted' ? null : element?.package_detail_id,
                        package_name: element?.package_type === 'Assorted' ? '' : element?.package_name,
                        package_type: 'Individual',
                        package_package_id: element?.package_type === 'Assorted' ? null : element?.package_id,
                        assorted_id: element?.package_type === 'Assorted' ? element?.package_detail_id : null,
                        assorted_name: element?.package_type === 'Assorted' ? element?.package_name : '',
                        assorted_package_id: element?.package_type === 'Assorted' ? element?.package_id : null,
                        assorted_head_id: element?.package_type === 'Assorted' ? element?.package_head_id : null,
                        drug_config_id: element?.drug_config_id ?? null,
                        sub_total_amount: totalAmt ?? 0,
                        drug_ms_id: element?.drug_ms_id ?? null,
                        pharmacy_id: element?.pharmacy_id ?? null,
                        sub_location_id: element?.sub_location_id ?? null,
                        membership_discount_percentage: element?.membership_discount_percentage || 0,
                    }
                    let MemberDiscount = element?.is_membership_discount_applied ? element?.discount_percentage : element?.membership_discount_percentage
                    if (MemberDiscount) {
                        serviceObj.membership_discount_percentage = true
                        if (element?.is_sharable) {
                            const baseTotalAmt = totalAmt
                            const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(serviceObj.doctor_percent, baseTotalAmt)
                            const updatedOldHos = CommonValidation.getDiscountAmountWithRound(serviceObj.hospital_percent, baseTotalAmt)
                            const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                            const disHos = CommonValidation.getDiscountAmountWithRound(MemberDiscount, updatedOldHos)
                            const conTlt = (+disDoc) + (+disHos)

                            serviceObj.total_amt = baseTotalAmt
                            serviceObj.total_with_discount = baseTotalAmt - disHos
                            serviceObj.old_doctor_amt = updatedOldDoc
                            serviceObj.old_hospital_amt = updatedOldHos
                            serviceObj.new_doctor_amt = updatedOldDoc - disDoc
                            serviceObj.new_hospital_amt = updatedOldHos - disHos
                            serviceObj.doctor_amt = updatedOldDoc - disDoc
                            serviceObj.hospital_amt = updatedOldHos - disHos
                            serviceObj.doc_discount_amt = disDoc
                            serviceObj.hos_discount_amt = disHos
                            serviceObj.hos_discount_percent = MemberDiscount
                            serviceObj.hos_discount_percent_w_r = MemberDiscount
                            serviceObj.concession_amt = CommonValidation.formatAmount(conTlt)
                            serviceObj.concession_percent = MemberDiscount
                            serviceObj.concession_percent_w_r = MemberDiscount
                            serviceObj.concession_comments = "Membership concession"
                        } else {
                            serviceObj.concession_percent = MemberDiscount
                            serviceObj.concession_percent_w_r = MemberDiscount
                            serviceObj.total_with_discount = (totalAmt - CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt))
                            serviceObj.concession_amt = +CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt)
                        }
                    }
                    newOrderList?.push(serviceObj)
                }
            }
            return { orderList: newOrderList, surgeryId: surgery_request_id };
        } catch (error) {
            errorMessage(error.message)
        }
    }

    useEffect(() => {
        let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
        if (formState?.patientData?.patient_id && (formState?.patientData?.id || formState?.patientData?.appointment_id) && LoggedData?.module_name !== "Doctor") {
            try {
                const { patient_id, patient_type, appointment_id, id, doctor_id, ward_id, speciality_id } = formState?.patientData || {};
                let startDate = new Date()
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
                let params = ""
                if (appointment_id) {
                    params = `?module_type=OP&appointment_id=${appointment_id}`;
                } else if (id) {
                    params = `?module_type=IP&ip_admission_id=${id}`;
                }
                params = params + `&patient_type=${patient_type ? patient_type : ''}&patient_id=${patient_id ? patient_id : ''}&bill_date=${date}&bill_time=${Aptime}&doctor_id=${doctor_id ? doctor_id : ''}&ward_id=${ward_id ? ward_id : ''}`
                if (localGetItem('enable_specialization_auto_bill') == "true") {
                    params += `&specialization_id=${speciality_id || ''}`;
                }
                RestAPIService.getAll(Serviceurls.NEW_AUTO_BILLING_GET + params)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            let serviceData = response?.data?.data?.filter((list)=>(list?.autobilling_type !== "yearly"));
                            let serviceList = setAutoBillData(serviceData)
                            
                            let AnnualserviceData = response?.data?.data?.filter((list)=>(list?.autobilling_type === "yearly"));
                            if(AnnualserviceData?.length){
                                setAnnualFeeList(AnnualserviceData)
                            }

                            setformState((prev) => ({ ...prev, orderList: [...prev.orderList, ...serviceList?.orderList], surgeryId: serviceList?.surgeryId }));
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error.message)
                        }
                    })
            } catch (error) {
                errorMessage(error.message)
            }
        }
    }, [formState?.patientData?.patient_id])


    useEffect(() => {
        if (formState?.consultant_doc && formState?.employeerID) {
            getCorporateServiceList();
        }
    }, [formState?.consultant_doc, formState?.employeerID]);

    useEffect(() => {
        if (formState?.patientData?.id) {
            getWardList();
        }
    }, [formState?.patientData?.id]);

    useEffect(() => {
        if (disableBtn) {
            postOrderDetails();
        }
    }, [disableBtn]);

    useEffect(() => {
        if (!formState.patientData?.appointment_id && !formState.patientData?.id) return;
        if (getCachevalue("OrderID")) {
            let orderID = getCachevalue("OrderID");
            let apiUrl = formState?.patientData?.appointment_id
                ? `${Serviceurls.BILLING_OP_PENDING_ORDER_LIST}?order_id=${orderID}&appointment_id=${formState.patientData.appointment_id}`
                : `${Serviceurls.BILLING_IP_PENDING_ORDER_LIST}?order_id=${orderID}&ip_admission_id=${formState.patientData.id}`;
            try {
                setIsLoader(true);
                RestAPIService.getAll(apiUrl)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            setIsLoader(false);
                            setserviceDate(new Date(response?.data?.data[0]?.order_date))
                            setorderDate(new Date(response?.data?.data[0]?.order_date))
                            if(response?.data?.data[0]?.order_date){
                                setDateTimeChanged(true)
                            }
                            setformState((prev) => {
                                let orderList = [];

                                if (formState?.patientData?.appointment_id) {
                                    const orderItems = response?.data?.data[0]?.order_line_items || [];
                                    const pendingItems = orderItems.filter(item => item.order_status === "Pending");
                                    let FinalList = []
                                    pendingItems?.forEach((element) => {
                                        let total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount
                                        let totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount
                                        const concession_amt = element?.discount_amount ? element?.discount_amount : 0
                                        const concession_percent = element?.discount_percentage ? element?.discount_percentage : 0

                                        const oldDocAmt = element?.old_doctor_fee ? element?.old_doctor_fee : element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                                        const oldHosAmt = element?.old_hospital_fee ? element?.old_hospital_fee : element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                                        const newDocAmt = element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                                        const newHosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                                        const docAmt = element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                                        const hosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                                        const docPer = element?.doctor_share_percent ? element?.doctor_share_percent : ''
                                        const hosPer = element?.hospital_share_percent ? element?.hospital_share_percent : ''

                                        const disDocAmt = (+oldDocAmt) - (+newDocAmt)
                                        const disHosAmt = (+oldHosAmt) - (+newHosAmt)
                                        const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
                                        const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)

                                        const sub_total_amount = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : 0
                                        const old_time_taken = element?.service_old_unit_count ? element?.service_old_unit_count : element?.service_unit ? element?.service_unit : null

                                        let obj = {
                                            ...element,
                                            total_with_discount: total_with_discount,
                                            total_amount: total_with_discount,
                                            total_amt: totalAmt ?? 0,
                                            concession_amt: concession_amt,
                                            concession_percent: concession_percent,
                                            concession_percent_w_r: +((+concession_percent)?.toFixed(2)),
                                            doctor_amt: docAmt,
                                            doctor_percent: docPer,
                                            old_doctor_amt: oldDocAmt,
                                            new_doctor_amt: newDocAmt,
                                            hospital_amt: hosAmt,
                                            hospital_percent: hosPer,
                                            old_hospital_amt: oldHosAmt,
                                            new_hospital_amt: newHosAmt,
                                            doc_discount_amt: disDocAmt,
                                            doc_discount_percent: disDocPer || '',
                                            doc_discount_percent_w_r: +CommonValidation.formatAmount(disDocPer),
                                            hos_discount_amt: disHosAmt,
                                            hos_discount_percent: disHosPer || '',
                                            hos_discount_percent_w_r: CommonValidation.formatAmount(disHosPer),
                                            doctor_percent_w_r: +((+docPer)?.toFixed(2)),
                                            hospital_percent_w_r: +((+hosPer)?.toFixed(2)),
                                            sub_total_amount: sub_total_amount,
                                            hours: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[0] : '',
                                            minutes: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[1] : '',
                                            interval_time: element.interval_time,
                                            interval_amount: element.interval_amount,
                                            membership_discount_percentage: element?.is_membership_discount_applied ? element?.discount_percentage : 0,
                                            old_time_taken: old_time_taken,
                                            start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                                            end_date: null,
                                        }
                                        FinalList.push(obj)
                                    })
                                    orderList = FinalList || [];
                                } else {
                                    const orderItems = response?.data?.data[0]?.order_line_items || [];
                                    setdupOrdersummary(orderItems)
                                    const pendingItems = orderItems.filter(item => item.is_processed == false);
                                    let FinalList = []
                                    pendingItems?.forEach((element) => {
                                        let total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount
                                        let totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount
                                        const concession_amt = element?.discount_amount ? element?.discount_amount : 0
                                        const concession_percent = element?.discount_percentage ? element?.discount_percentage : 0

                                        const oldDocAmt = element?.old_doctor_fee ? element?.old_doctor_fee : element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                                        const oldHosAmt = element?.old_hospital_fee ? element?.old_hospital_fee : element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                                        const newDocAmt = element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                                        const newHosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                                        const docAmt = element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                                        const hosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                                        const docPer = element?.doctor_share_percent ? element?.doctor_share_percent : ''
                                        const hosPer = element?.hospital_share_percent ? element?.hospital_share_percent : ''

                                        const disDocAmt = (+oldDocAmt) - (+newDocAmt)
                                        const disHosAmt = (+oldHosAmt) - (+newHosAmt)
                                        const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
                                        const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)

                                        const sub_total_amount = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : 0
                                        const old_time_taken = element?.service_old_unit_count ? element?.service_old_unit_count : element?.service_unit ? element?.service_unit : null

                                        let obj = {
                                            ...element,
                                            total_with_discount: total_with_discount,
                                            total_amount: total_with_discount,
                                            total_amt: totalAmt ?? 0,
                                            concession_amt: concession_amt,
                                            concession_percent: concession_percent,
                                            concession_percent_w_r: +((+concession_percent)?.toFixed(2)),
                                            doctor_amt: docAmt,
                                            doctor_percent: docPer,
                                            old_doctor_amt: oldDocAmt,
                                            new_doctor_amt: newDocAmt,
                                            hospital_amt: hosAmt,
                                            hospital_percent: hosPer,
                                            old_hospital_amt: oldHosAmt,
                                            new_hospital_amt: newHosAmt,
                                            doc_discount_amt: disDocAmt,
                                            doc_discount_percent: disDocPer || '',
                                            doc_discount_percent_w_r: +CommonValidation.formatAmount(disDocPer),
                                            hos_discount_amt: disHosAmt,
                                            hos_discount_percent: disHosPer || '',
                                            hos_discount_percent_w_r: CommonValidation.formatAmount(disHosPer),
                                            doctor_percent_w_r: +((+docPer)?.toFixed(2)),
                                            hospital_percent_w_r: +((+hosPer)?.toFixed(2)),
                                            sub_total_amount: sub_total_amount,
                                            hours: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[0] : '',
                                            minutes: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[1] : '',
                                            interval_time: element.interval_time,
                                            interval_amount: element.interval_amount,
                                            old_time_taken: old_time_taken,
                                            start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                                            end_date: null,
                                            membership_discount_percentage: element?.is_membership_discount_applied ? element?.discount_percentage : 0,
                                        }
                                        FinalList.push(obj)
                                    })
                                    orderList = FinalList || [];
                                }

                                return {
                                    ...prev,
                                    orderList,
                                    fromOrderSummary: true
                                };
                            });
                            clearCachevalue('OrderID')
                        }
                    }).catch((error) => {
                        setIsLoader(false);
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error.message)
                        }
                    })
            } catch (error) {
                setIsLoader(false);
                errorMessage(error.message)
            }
        }
        getOrderCardAmt();
    }, [formState?.patientData?.appointment_id || formState?.patientData?.id])

    useEffect(() => {
        let PatientData = opOrder ? getCachevalue("patientData") : getCachevalue("IppatientData");
        if (PatientData) {
            setformState((prev) => ({
                ...prev,
                patientData: JSON.parse(PatientData)
            }));
        }
        if (formState?.selected_bill_doc && ((formState?.selectedward && formState?.patientData?.id) || formState?.patientData?.appointment_id)) {
            getServiceListData()
        } else {
            setformState((prev) => ({ ...prev, serviceSugg: [] }))
        }
    }, [formState?.selected_bill_doc, formState?.selectedward]);

    useEffect(() => {
        if (formState?.isEdit) {
            billingContainerRef.current?.focus();
        }
    }, [formState?.isEdit]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key !== 'Enter') return;

            const activeEl = document.activeElement;

            // Either container OR any child
            const isInsideBilling =
                billingContainerRef.current === activeEl ||
                billingContainerRef.current?.contains(activeEl);

            if (!isInsideBilling) return;

            // Autocomplete dropdown open
            if (document.querySelector('[role="listbox"]')) return;

            const isAddDisabled =
                !formState.selected_bill_doc ||
                !formState.selected_service ||
                (formState?.fromOrderSummary && !formState?.isEdit) ||
                !formState?.patientData?.doctor_id ||
                (!formState?.selectedward && formState?.patientData?.id) ||
                formState?.patientData?.is_final_bill_initiated || !userAccess?.editAccess;

            if (isAddDisabled) return;

            e.preventDefault();
            e.stopPropagation();

            if (formState.selected_service?.autobilling_type === 'yearly') {
                setAnnualFeeAlert(true);
            } else {
                onAddHandler();
            }
        };

        document.addEventListener('keydown', handleKeyDown, true);

        return () =>
            document.removeEventListener('keydown', handleKeyDown, true);
    }, [formState]);

    const deleteOrderList = () => {
        try {
            let data = {
                remarks: formState.cancel_reason,
                line_item_id: formState?.deleted_data?.assorted_package_id || formState?.deleted_data?.package_detail_id ? null : formState?.deleted_service,
                order_id: formState?.deleted_data?.op_order_id ?? null,
                assorted_package_id: formState?.deleted_data?.assorted_package_id ?? null,
                package_id: formState?.deleted_data?.package_detail__package_id ?? null
            };
            setIsLoader(true)
            const apiUrl = formState?.patientData?.appointment_id ? Serviceurls.BILLING_ORDER_LIST : Serviceurls.BILLING_ORDER_LIST_IP;
            RestAPIService.delete(`${apiUrl}`, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setIsLoader(false)
                        setformState((prev) => {
                            const updatedOrderList = prev.orderList.filter((_, i) => {
                                if (_?.assorted_package_id || _?.package_detail__package_id) {
                                    return _?.op_order_id !== formState?.deleted_data?.op_order_id
                                } else {
                                    return i !== formState?.deleted_service_index
                                }
                            });
                            return {
                                ...prev,
                                openDeletePopup: false,
                                deleted_service: null,
                                cancel_reason: '',
                                deleted_service_index: null,
                                orderList: updatedOrderList,
                                deleted_data: null
                            };
                        });
                    }
                }).catch(e => {
                    setIsLoader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setIsLoader(false)
            errorMessage(e.message)
        }
    }

    const getServiceListData = (searchKey = '') => {
        try {
            let moduleType = formState.patientData?.appointment_id ? 'OP' : formState.patientData?.id ? 'IP' : null;
            const getFormattedPatientType = (type) => {
                const mapping = {
                    old_patient: "Old Patient",
                    new_patient: "New Patient",
                    review_patient: "Review Patient"
                };
                return mapping[type] || type;
            };
            setIsLoader(true);
            let patientType = getFormattedPatientType(formState.patientData?.patient_type || '');
            RestAPIService.getAll(
                Serviceurls.NEW_BILLING_OP_SERVICE_GET +
                '?patient_type=' + patientType +
                '&module_type=' + moduleType +
                '&ward_id=' + (formState?.selectedward?.id || '') +
                '&doctor_id=' + formState.selected_bill_doc?.doctor_id +
                '&search_key=' + searchKey +
                '&patient_id=' + (formState.patientData.patient_id || '') + 
                (formState.patientData?.appointment_id ? `&appointment_id=${formState.patientData?.appointment_id}` : formState.patientData?.id ? `&ip_admission_id=${formState.patientData?.id}` : "")

            ).then((response) => {
                if (response?.data?.status === 'success') {
                    setIsLoader(false);
                    setformState((prev) => ({ ...prev, serviceSugg: response?.data?.data }))
                    if (!ServiceCount) {
                        setServiceCount(response.data.service_length > 1000 ? true : false)
                    }
                }
            }).catch((error) => {
                setIsLoader(false);
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getInlineServiceListData = (doc_id, ward_id, service_id, index) => {
        try {
            let moduleType = formState.patientData?.appointment_id ? 'OP' : formState.patientData?.id ? 'IP' : null
            const getFormattedPatientType = (type) => {
                const mapping = {
                    old_patient: "Old Patient",
                    new_patient: "New Patient",
                    review_patient: "Review Patient"
                };
                return mapping[type] || type;
            };
            setIsLoader(true);
            let patientType = getFormattedPatientType(formState.patientData?.patient_type || '');
            RestAPIService.getAll(
                Serviceurls.NEW_BILLING_OP_SERVICE_GET +
                '?patient_type=' + patientType +
                '&module_type=' + moduleType +
                '&ward_id=' + (ward_id || '') +
                '&doctor_id=' + doc_id + '&service_id=' + service_id
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    const element = response.data.data[0];
                    setIsLoader(false);
                    setformState((prev) => {
                        const updatedOrderList = [...prev.orderList];
                        let amount = element?.service_charge;
                        updatedOrderList[index] = {
                            ...updatedOrderList[index],
                            rate_per_unit: amount, unit: element.unit,
                            unit_type: element.unit_type, total_amount: (amount * (1 + (element.gst_percent || 0) / 100)),
                            doctor_amt: element.doctor_share_amount, sub_total_amount: amount,
                            doctor_percent: element.doctor_share_percent, old_doctor_amt: element.doctor_share_amount,
                            new_doctor_amt: element.doctor_share_amount, hospital_amt: element.hospital_share_amount,
                            hospital_percent: element.hospital_share_percent, old_hospital_amt: element.hospital_share_amount,
                            new_hospital_amt: element.hospital_share_amount, interval_time: element.interval_time,
                            interval_amount: element.interval_amount, service_name: element.service_name,
                            service_head_name: element.service_head, service_code: element.service_code,
                            service_head_code: element.service_head_code, edit_unit: element.edit_unit,
                            edit_amount: element.edit_amount, edit_discount: element.edit_discount,
                            doctor_name: (element.doctor_name || formState?.patientData?.doctor_name), doctor_id: (element.doctor_id || formState?.patientData?.doctor_id),
                            gst_percent: element.gst_percent || 0, hours: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[0] : '',
                            minutes: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[1] : '',
                            service_details_id: element?.service_details_id,
                            service_head_id: element?.service_head_id, tempUnit: element?.unit, tempRate: element?.service_charge,
                            review_days: element?.review_days, review_count: element?.review_count,
                            charge_id: element?.charge_id, module_type: element?.module_type,
                            doctor_percent_w_r: element?.doctor_share_percent, hospital_percent_w_r: element?.hospital_share_percent, start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                            end_date: null, is_hospital: element?.is_hospital, ward_name: (element?.ward_name || formState?.patientData?.ward_name), ward_id: formState?.patientData?.ward_id,
                            doctor_list: formState?.orderList[index]?.doctor_list, ward_list: formState?.orderList[index]?.ward_list,
                            is_sharable: formState?.is_sharable,
                            is_consultation: formState?.is_consultation,
                            drug_config_id: formState?.drug_config_id ?? null,
                            drug_ms_id: formState?.drug_ms_id ?? null,
                            pharmacy_id: formState?.pharmacy_id ?? null,
                            sub_location_id: formState?.sub_location_id ?? null,
                        };
                        return { ...prev, orderList: updatedOrderList };
                    });
                }
            }).catch((error) => {
                setIsLoader(false);
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getTemplateList = (moduleType, parsedPatientData) => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_LIST + `?module_type=${moduleType}&patient_id=${parsedPatientData.patient_id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        setInsuToolOpen(true);
                        setformState((prev) => ({ ...prev, tempPackSugg: response?.data?.data }))
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    setInsuToolOpen(true);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            setInsuToolOpen(true);
            errorMessage(error.message)
        }
    }

    const getOrderCardAmt = () => {
        try {
            RestAPIService.getAll(Serviceurls.NEW_BILLING_ORDER_DEPTWISE + `?order_type=${opOrder ? "op" : "ip"}&${opOrder ? `appointment_id=${formState?.patientData?.appointment_id}` : `admission_id=${formState?.patientData?.id}`}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        const AmtValues = Object.entries(response?.data?.data)?.map(([key, value]) => ({
                            module: key,
                            amount: value
                        }));
                        setamtState(AmtValues)
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getBillingPatientData = (id) => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.FO_PATIENT_APPOINTMENT_DETAILS + `?appointment_id=${id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        setformState((prev) => ({ ...prev, employeerID: response?.data?.data?.employer_id }))
                        setConditionData(response?.data?.data)
                        if(response?.data?.data?.is_memberships){
                            setMembershipDetails({
                                is_memberships: response?.data?.data?.is_memberships,
                                membership_expair_date: response?.data?.data?.membership_expair_date,
                                membership_expiry_count: response?.data?.data?.membership_expiry_count,
                                membership_no_of_visit: response?.data?.data?.membership_no_of_visit,
                                membership_total_no_of_visit: response?.data?.data?.membership_total_no_of_visit,
                                membership_type: response?.data?.data?.membership_type,
                                membership_validity: response?.data?.data?.membership_validity,
                            })
                        }
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getIpAdmissionDetails = (id) => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.IP_PATIENT_DETAILS_NEW + `?admission_id=${id}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        let ResponseData = response?.data?.data[0]
                        if(ResponseData?.is_memberships){
                            setMembershipDetails({
                                is_memberships: ResponseData?.is_memberships,
                                membership_expair_date: ResponseData?.membership_expair_date,
                                membership_expiry_count: ResponseData?.membership_expiry_count,
                                membership_no_of_visit: ResponseData?.membership_no_of_visit,
                                membership_total_no_of_visit: ResponseData?.membership_total_no_of_visit,
                                membership_type: ResponseData?.membership_type,
                                membership_validity: ResponseData?.membership_validity,
                            })
                        }
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }


    const getWardList = () => {
        try {
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.WARD_CONFIG)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        let selectedWard = response?.data?.data?.find(ward => ward?.id === formState.patientData?.ward_id);
                        setformState((prev) => ({ ...prev, wardList: response?.data?.data, selectedward: selectedWard }))
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const getCorporateServiceList = () => {
        try {
            const getFormattedPatientType = (type) => {
                const mapping = {
                    old_patient: "Old Patient",
                    new_patient: "New Patient",
                    review_patient: "Review Patient"
                };

                return mapping[type] || type;
            };
            let patientType = getFormattedPatientType(formState.patientData?.patient_type || '');
            setIsLoader(true);
            RestAPIService.getAll(Serviceurls.BILLING_OP_CORPORATE_LIST + `?employer_id=${formState?.employeerID}&doctor_id=${formState.consultant_doc?.doctor_id}&patient_type=${patientType}&module=${loginInfo?.module_name === "Laboratory" ? 'LAB' :
                loginInfo?.module_name === "Radiology" ? "RADIOLOGY" : "OP"}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        setformState((prev) => ({ ...prev, corporatesugg: response?.data?.data }))
                    }
                }).catch((error) => {
                    setIsLoader(false);
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }

    const hasDuplicateBetweenArrays = (arr1, arr2) => {
        const seen = new Set();
        for (const obj of arr1) {
            if (obj.package_id) {
                const key = `${obj.package_id}-${obj.service_head_name}`;
                seen.add(key);
            } else {
                const key = obj?.drug_ms_id ? `${obj?.drug_ms_id}-${obj.doctor_id}` : obj?.drug_config_id ? `${obj?.drug_config_id}-${obj.doctor_id}` : obj?.package_detail_id ? `${obj?.package_detail_id}-${obj.doctor_id}` : `${obj.service_details_id || obj?.service_charge_id}-${obj.doctor_id}`
                const compositeKey = `${key}-${obj.service_head_name }`;
                seen.add(compositeKey);
            }
        }
        for (const obj of arr2) {
            if (obj.package_id) {
                const key = `${obj.package_id}-${obj.service_head_name}`;
                if (seen.has(key)) {
                    return true;
                }
            } else {
                const key = obj?.drug_ms_id ? `${obj?.drug_ms_id}-${obj.doctor_id}` : obj?.drug_config_id ? `${obj?.drug_config_id}-${obj.doctor_id}` : obj?.package_detail_id ? `${obj?.package_detail_id}-${obj.doctor_id}` : `${obj.service_details_id || obj?.service_charge_id}-${obj.doctor_id}`
                const compositeKey = `${key}-${obj.service_head_name }`;
                if (seen.has(compositeKey)) {
                    return true;
                }
            }
        }
        return false;
    }

    const hasDuplicateEntries = (arr) => {
        const seen = new Set();
        for (const obj of arr) {
            if (obj.package_id) {
                const key = `${obj.package_id}-${obj.service_head_name}`;
                if (seen.has(key)) {
                    return true;
                }
                seen.add(key);
            } else {
                const key = obj?.drug_ms_id ? `${obj?.drug_ms_id}-${obj.doctor_id}` : obj?.drug_config_id ? `${obj?.drug_config_id}-${obj.doctor_id}` : obj?.package_detail_id ? `${obj?.package_detail_id}-${obj.doctor_id}` : `${obj.service_details_id || obj?.service_charge_id}-${obj.doctor_id}`
                const compositeKey = `${key}-${obj.service_head_name }`;
                if (seen.has(compositeKey)) {
                    return true;
                }
                seen.add(compositeKey);
            }
        }
        return false;
    }

    const getTemplateData = (value) => {
        const patientTypeMap = {
            old_patient: "Old Patient",
            new_patient: "New Patient",
            review_patient: 'Review Patient'
        };
        try {
            setIsLoader(true);
            let patientType = patientTypeMap[formState.patientData?.patient_type] || formState.patientData?.patient_type;
            let template_id = value?.template_id ? value?.template_id : ''
            let package_id = value?.package_id ? value?.package_id : ''
            let assorted_id = value?.assorted_package_id ? value?.assorted_package_id : ''
            // let doctor_id = formState.consultant_doc?.doctor_id || '';
            let doctor_id = formState.selected_bill_doc?.doctor_id ? formState.selected_bill_doc?.doctor_id : formState.selected_bill_doc_id
            let wardID = formState.patientData?.ward_id || '';

            const isDuplicate = formState.orderList?.some(item => {
                if (template_id) {
                    return item?.template_id === template_id;
                } else if (package_id) {
                    return item?.package_id === package_id;
                } else if (assorted_id) {
                    return item?.assorted_id === assorted_id
                }
                return false;
            });

            if (isDuplicate) {
                setIsLoader(false);
                if (template_id) {
                    errorMessage("Service Template Already Exist.");
                } else {
                    errorMessage('Service Package Already Exist.');
                }
                return;
            }

            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_GET
                + '?template_id=' + template_id +
                '&package_id=' + package_id +
                '&doctor_id=' + doctor_id +
                '&patient_type=' + patientType +
                '&ward_id=' + wardID +
                '&assorted_id=' + assorted_id +
                '&patient_id=' + formState.patientData.patient_id +
                (formState.patientData?.appointment_id ? `&appointment_id=${formState.patientData?.appointment_id}` : formState.patientData?.id ? `&ip_admission_id=${formState.patientData?.id}` : "")

            ).then((response) => {
                if (response?.data?.status === 'success') {
                    setIsLoader(false);
                    let templateList = [];
                    let data = response?.data?.data?.package_line ? response?.data?.data?.package_line : response?.data?.data?.template_line
                    let templateData = response?.data?.data;
                    data?.forEach((element, index) => {
                        let amount = element?.drug_config_id ? element?.service_charge / element?.unit : element?.service_charge;
                        let total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount
                        let totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount
                        let dividerUnit = (element?.unit && element?.unit_type !== "Hrs") ? element?.unit : 1;
                        let serviceObj = {
                            rate_per_unit: element?.service_charge ? (element?.service_charge / dividerUnit) : 0,
                            unit: element?.unit,
                            unit_type: element?.unit_type,
                            total_amt: totalAmt || 0,
                            sub_total_amount: totalAmt || 0,
                            total_with_discount: total_with_discount || 0,
                            doctor_amt: element?.doctor_share_amount,
                            doctor_percent: element?.doctor_share_percent,
                            old_doctor_amt: element?.doctor_share_amount,
                            new_doctor_amt: element?.doctor_share_amount,
                            hospital_amt: element?.hospital_share_amount,
                            hospital_percent: element?.hospital_share_percent,
                            old_hospital_amt: element?.hospital_share_amount,
                            new_hospital_amt: element?.hospital_share_amount,
                            interval_time: element?.interval_time,
                            interval_amount: element?.interval_amount,
                            service_name: element?.service_name,
                            service_head_name: element?.service_head,
                            service_code: element?.service_code,
                            service_head_code: element?.service_head_code,
                            edit_unit: element?.edit_unit,
                            edit_amount: element?.edit_amount,
                            edit_discount: element?.edit_discount,
                            doctor_name: element?.doctor_name,
                            doctor_id: element?.doctor_id,
                            start_time: element?.start_time,
                            end_time: element?.end_time,
                            gst_percent: element?.gst_percent || 0,
                            hours: element?.unit_type === 'Hrs' ? element?.unit?.toString()?.split(":")[0] : '',
                            minutes: element?.unit_type === 'Hrs' ? element?.unit?.toString()?.split(":")[1] : '',
                            service_details_id: element?.service_details_id,
                            doctor_id: element?.doctor_id,
                            review_days: element?.review_days,
                            review_count: element?.review_count,
                            charge_id: element?.charge_id || element?.service_charge_id,
                            doctor_name: element?.doctor_name,
                            module_type: element?.module_type,
                            doctor_percent_w_r: +(element?.doctor_share_percent?.toFixed(2)),
                            hospital_percent_w_r: +(element?.hospital_share_percent?.toFixed(2)),
                            start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                            end_date: null,
                            is_hospital: element?.is_hospital,
                            service_head_id: element?.service_head_id,
                            op_order_number: element?.op_order_number,
                            old_time_taken: element.unit_type === 'Hrs' ? element?.service_old_unit_count : null,
                            doc_discount_amt: '',
                            doc_discount_percent: '',
                            doc_discount_percent_w_r: '',
                            hos_discount_amt: '',
                            hos_discount_percent: '',
                            hos_discount_percent_w_r: '',
                            is_sharable: element?.is_sharable,
                            is_consultation: element?.is_consultation,
                            ward_name: !element?.ward_list ? formState?.patientData?.ward_name : null,
                            ward_id: !element?.ward_list ? formState?.patientData?.ward_id : null,
                            doctor_list: element?.doctor_list,
                            ...(element?.ward_list ? { ward_list: element?.ward_list } : null),
                            ...(element.template_detail_id ? { template_id: element.template_detail_id, template_name: templateData.template_name } :
                                (element?.package_detail_id && templateData?.package_type === 'Package') ? { package_id: element?.package_detail_id, package_name: templateData?.package_name, package_type: 'package', package_package_id: element?.package_id } :
                                    (element?.package_detail_id && templateData?.package_type === 'Assorted') ? { assorted_id: element?.package_detail_id, assorted_name: templateData?.package_name, assorted_package_id: element?.package_id, assorted_head_id: element?.package_head_id, package_type: 'Assorted' } : null),
                            billing_display: templateData?.billing_display ?? null,
                            package_type: templateData?.package_type ?? 'Individual',
                            module_type: element?.module_type ?? '',
                            drug_config_id: element?.drug_config_id ?? null,
                            sub_total_amount: totalAmt ?? 0,
                            drug_ms_id: element?.drug_ms_id ?? null,
                            pharmacy_id: element?.pharmacy_id ?? null,
                            sub_location_id: element?.sub_location_id ?? null,
                        }
                        let MemberDiscount = element?.is_membership_discount_applied ? element?.discount_percentage : element?.membership_discount_percentage
                        if (MemberDiscount) {
                            serviceObj.membership_discount_percentage = true
                            if (element?.is_sharable) {
                                const baseTotalAmt = totalAmt
                                const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(serviceObj.doctor_percent, baseTotalAmt)
                                const updatedOldHos = CommonValidation.getDiscountAmountWithRound(serviceObj.hospital_percent, baseTotalAmt)
                                const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                                const disHos = CommonValidation.getDiscountAmountWithRound(MemberDiscount, updatedOldHos)
                                const conTlt = (+disDoc) + (+disHos)

                                serviceObj.total_amt = baseTotalAmt
                                serviceObj.total_with_discount = baseTotalAmt - disHos
                                serviceObj.old_doctor_amt = updatedOldDoc
                                serviceObj.old_hospital_amt = updatedOldHos
                                serviceObj.new_doctor_amt = updatedOldDoc - disDoc
                                serviceObj.new_hospital_amt = updatedOldHos - disHos
                                serviceObj.doctor_amt = updatedOldDoc - disDoc
                                serviceObj.hospital_amt = updatedOldHos - disHos
                                serviceObj.doc_discount_amt = disDoc
                                serviceObj.hos_discount_amt = disHos
                                serviceObj.hos_discount_percent = MemberDiscount
                                serviceObj.hos_discount_percent_w_r = MemberDiscount
                                serviceObj.concession_amt = CommonValidation.formatAmount(conTlt)
                                serviceObj.concession_percent = MemberDiscount
                                serviceObj.concession_percent_w_r = MemberDiscount
                                serviceObj.concession_comments = "Membership concession"
                            } else {
                                serviceObj.concession_percent = MemberDiscount
                                serviceObj.concession_percent_w_r = MemberDiscount
                                serviceObj.total_with_discount = (totalAmt - CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt))
                                serviceObj.concession_amt = +CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt)
                            }
                        }
                        templateList?.push(serviceObj)
                    })
                    // const duplicateServices = formState.orderList?.filter(orderItem =>
                    //     templateList.some(newItem => (orderItem.service_details_id === newItem.service_details_id || orderItem.assorted_package_id === newItem.assorted_package_id || orderItem.package_id === newItem.package_id) && orderItem.doctor_id === newItem.doctor_id)
                    // );
                    let hasDuplicate = hasDuplicateBetweenArrays(formState.orderList, templateList)

                    if (hasDuplicate) {
                        setIsLoader(false);
                        settempDup(templateList);
                        setIsWarning(true);

                        // setDuplicateIds(duplicateServices.map(item => ({
                        //     service_details_id: item.service_details_id ?? null,
                        //     doctor_id: item.doctor_id ?? null,
                        //     assorted_package_id: item?.assorted_package_id ?? null,
                        //     package_id: item?.package_id ?? null
                        // })));

                        // return;
                    } else {
                        setformState((prev) => ({
                            ...prev,
                            orderList: [...prev.orderList, ...templateList],
                        }));
                    }
                }
            }).catch((error) => {
                setIsLoader(false);
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setIsLoader(false);
            errorMessage(error.message)
        }
    }


    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
        setDisableBtn(false)
    };

    const successMessage = (msg) => {
        setsuccessMsgText(msg);
        setsuccessMsg(true);
        setDisableBtn(false)
    };

    const renderDeletePopup = () => {
        try {
            return (
                <Dialog open={formState.openDeletePopup} maxWidth='sm' fullWidth>
                    <Box component={'div'} className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'1px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600} color={'#bb3c3c'}>Cancellation Remarks</Typography>
                            <IconButton onClick={() => setformState((prev) => ({ ...prev, openDeletePopup: false, deleted_service: null, cancel_reason: '', deleted_service_index: null, deleted_data: null }))}>
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p='0.5rem'>
                            {/* {formState?.deleted_data?.assorted_package_id || formState?.deleted_data?.package_detail_id ?
                                <Box>
                                    <Typography color={'#bb3c3c'} fontWeight={600} fontSize={'0.9rem'}>* Cancelling a single item from Package/Assorted will affect the entire package/Assorted.</Typography>
                                </Box> : null} */}
                            <Box component={'div'} mt={'1rem'}>
                                <TextField
                                    multiline
                                    size='small'
                                    fullWidth
                                    rows={4}
                                    inputProps={{ maxLength: 250 }}
                                    value={formState.cancel_reason}
                                    label='Comments Here *'
                                    onChange={(e) => {
                                        setformState((prev) => ({ ...prev, cancel_reason: e.target.value }))
                                    }}
                                />
                            </Box>
                            {formState.deleted_data?.is_advance_adjusted ? <Typography sx={{ color: "red", margin: "0.3vw", fontSize: "0.9vw" }}>{`The adjusted advance amount of ${AmountFormat(formState.deleted_data?.total_amount)} will be added back to the advance.`}</Typography> : null}
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mb={'0.5rem'}>
                            <Button variant='outlined'
                                color='error'
                                sx={{ textTransform: 'capitalize', mr: '1rem', height: COMMON_STYLES.HEIGHT }}
                                onClick={() => setformState((prev) => ({ ...prev, openDeletePopup: false, deleted_service: null, deletedType: '', cancel_reason: '', deleted_service_index: null, deleted_data: null }))}
                            >Close</Button>
                            <Button variant='contained'
                                color='error'
                                sx={{ textTransform: 'capitalize', mr: '1rem', height: COMMON_STYLES.HEIGHT }}
                                onClick={() => {
                                    if (!formState.cancel_reason.trim()) {
                                        errorMessage('Enter Cancellation Remarks');
                                        return;
                                    }
                                    deleteOrderList();
                                }}
                            >Cancel</Button>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onSelectServiceHandler = (value) => {
        try {
            setformState((prev) => {
                let serviceData = {}
                if (value !== null) {
                    if ('emergency' in value) {
                        serviceData = value?.emergency
                    } else if ('holiday' in value) {
                        serviceData = value?.holiday
                    } else {
                        serviceData = value
                    }
                }

                const sharedFields = {
                    rate_per_unit: serviceData.service_charge,
                    unit: serviceData.unit,
                    unit_type: serviceData.unit_type,
                    total_amt: serviceData.service_charge,
                    total_with_discount: serviceData.service_charge,
                    doctor_amt: serviceData.doctor_share_amount,
                    doctor_percent: serviceData.doctor_share_percent,
                    old_doctor_amt: serviceData.doctor_share_amount,
                    new_doctor_amt: serviceData.doctor_share_amount,
                    hospital_amt: serviceData.hospital_share_amount,
                    hospital_percent: serviceData.hospital_share_percent,
                    old_hospital_amt: serviceData.hospital_share_amount,
                    new_hospital_amt: serviceData.hospital_share_amount,
                    interval_time: serviceData.interval_time,
                    interval_amount: serviceData.interval_amount,
                    service_name: serviceData.service_name,
                    service_head_name: serviceData.service_head,
                    service_code: serviceData.service_code,
                    service_head_code: serviceData.service_head_code,
                    edit_unit: serviceData.edit_unit,
                    edit_amount: serviceData.edit_amount,
                    edit_discount: serviceData.edit_discount,
                    doctor_name: serviceData.doctor_name,
                    doctor_id: serviceData.doctor_id,
                    start_time: serviceData.start_time,
                    end_time: serviceData.end_time,
                    gst_percent: serviceData.gst_percent || 0,
                    hours: serviceData.unit_type === 'Hrs' ? serviceData.unit?.toString()?.split(":")[0] : '',
                    minutes: serviceData.unit_type === 'Hrs' ? serviceData.unit?.toString()?.split(":")[1] : '',
                    service_details_id: serviceData?.service_details_id,
                    doctor_id: serviceData?.doctor_id,
                    review_days: serviceData?.review_days,
                    review_count: serviceData?.review_count,
                    charge_id: serviceData?.charge_id,
                    doctor_name: serviceData?.doctor_name,
                    module_type: serviceData?.module_type,
                    doctor_percent_w_r: +(serviceData?.doctor_share_percent?.toFixed(2)),
                    hospital_percent_w_r: +(serviceData?.hospital_share_percent?.toFixed(2)),
                    start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                    end_date: null,
                    is_hospital: serviceData?.is_hospital,
                    service_head_id: serviceData?.service_head_id,
                    op_order_number: serviceData?.op_order_number,
                    old_time_taken: serviceData.unit_type === 'Hrs' ? serviceData?.unit : null,
                    doc_discount_amt: '',
                    doc_discount_percent: '',
                    doc_discount_percent_w_r: '',
                    hos_discount_amt: '',
                    hos_discount_percent: '',
                    hos_discount_percent_w_r: '',
                    is_sharable: serviceData?.is_sharable,
                    is_consultation: serviceData?.is_consultation,
                    concession_amt: serviceData?.concession_amt,
                    concession_percent: serviceData?.concession_percent,
                    concession_percent_w_r: serviceData?.concession_percent_w_r,
                    concession_comments: serviceData?.concession_comments,
                };

                if (serviceData?.membership_discount_percentage) {
                    sharedFields.membership_discount_percentage = true
                    if (serviceData?.is_sharable) {
                        const baseTotalAmt = serviceData.service_charge;
                        const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(sharedFields.doctor_percent, baseTotalAmt)
                        const updatedOldHos = CommonValidation.getDiscountAmountWithRound(sharedFields.hospital_percent, baseTotalAmt)
                        const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                        const disHos = CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, updatedOldHos)
                        const conTlt = (+disDoc) + (+disHos)

                        sharedFields.total_amt = baseTotalAmt
                        sharedFields.total_with_discount = (serviceData.service_charge - disHos)
                        sharedFields.old_doctor_amt = updatedOldDoc
                        sharedFields.old_hospital_amt = updatedOldHos
                        sharedFields.new_doctor_amt = updatedOldDoc - disDoc
                        sharedFields.new_hospital_amt = updatedOldHos - disHos
                        sharedFields.doctor_amt = updatedOldDoc - disDoc
                        sharedFields.hospital_amt = updatedOldHos - disHos
                        sharedFields.doc_discount_amt = disDoc
                        sharedFields.hos_discount_amt = disHos
                        sharedFields.hos_discount_percent = serviceData?.membership_discount_percentage
                        sharedFields.hos_discount_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.concession_amt = CommonValidation.formatAmount(conTlt)
                        sharedFields.concession_percent = serviceData?.membership_discount_percentage
                        sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.concession_comments = "Membership concession"
                    } else {
                        sharedFields.concession_percent = serviceData?.membership_discount_percentage
                        sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.total_with_discount = (sharedFields.total_amt - CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt))
                        sharedFields.concession_amt = +CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt)
                    }
                }

                return {
                    ...prev,
                    selected_service: value !== null ? serviceData : null,
                    service_data: {
                        ...prev.service_data,
                        ...sharedFields,
                    },
                };
            });

        } catch (error) {
            errorMessage(error.message)
        }
    }

    const popupTextBox = (key, values, multiline, row, labels, readOnly, width) => {
        try {
            return (
                <TextField
                    autoComplete='off'
                    size='small'
                    sx={{ width: width || '13dvw' }}
                    value={values || ""}
                    onChange={(e) => onPopupChangeHandler(e, key)}
                    multiline={multiline}
                    rows={row}
                    label={labels}
                    InputProps={{ readOnly: readOnly, emed_tid: key }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onPopupChangeHandler = (e, key) => {
        try {
            let value = e.target.value;

            setPopupValues((prev) => {
                let updateState = {};

                const pageType = formState?.patientData?.appointment_id ? 'op' : 'ip';
                const admissionTime = new Date(formState?.patientData?.admission_date);
                const currentTime = new Date();

                const diffMs = (currentTime - admissionTime) + 3600000;
                const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
                const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                const minHoursForIP = diffHours < 24 ? 24 : diffHours;
                const minMinutesForIP = diffHours < 24 ? 59 : diffMinutes;

                const maxHours = pageType === 'op' ? 24 : minHoursForIP;
                const maxMinutes = pageType === 'op' ? 59 : minMinutesForIP;

                switch (key) {
                    case 'doctor_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.hospital_amt)
                            updateState.doctor_amt = value;
                            updateState.new_doctor_amt = value;
                            updateState.old_doctor_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.hospital_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(value, totalAmt)
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt)
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(+popupValues.hospital_amt, totalAmt)
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(+popupValues.hospital_amt, totalAmt)
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(+popupValues.doc_discount_percent, value)
                        }
                        break;
                    case 'hospital_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.doctor_amt)
                            updateState.hospital_amt = value;
                            updateState.new_hospital_amt = value;
                            updateState.old_hospital_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.doctor_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(+popupValues.doctor_amt, totalAmt) || 0
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(+popupValues.doctor_amt, totalAmt) || 0
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(value, totalAmt) || 0
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt) || 0
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(+popupValues.hos_discount_percent, value) || 0
                        }
                        break;
                    case 'doctor_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_doctor_amt || value === '') {
                            updateState.doc_discount_amt = value
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(+popupValues.old_doctor_amt - value) || 0
                            updateState.doc_discount_percent = +CommonValidation.getDiscountPercentage(value, +popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, +popupValues.old_doctor_amt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(+popupValues.old_doctor_amt - value) || 0
                        }
                        break;
                    case 'hospital_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_hospital_amt || value === '') {
                            updateState.hos_discount_amt = value
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0
                            updateState.hos_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0
                        }
                        break;
                    case 'doctor_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent = value
                            updateState.doc_discount_percent_w_r = value
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0
                        }
                        break;
                    case 'hospital_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmount(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent = value
                            updateState.hos_discount_percent_w_r = value
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0
                        }
                        break;
                    case 'concession_comments':
                        if (value?.length <= 500 || value === '') {
                            updateState.concession_comments = value
                        }
                        break;
                    case 'individual_concession_comments':
                        if (value?.length <= 500 || value === '') {
                            updateState.individual_concession_comments = value
                        }
                        break;
                    case 'line_item_remarks':
                        updateState.line_item_remarks = clampLineItemRemarks(value)
                        break;
                    case 'hours':
                        if (value === "" || (CommonValidation.numberOnly(value) && value >= 0 && value <= 24) && pageType === 'op') {
                            updateState.hours = value;
                            if (value === '24') {
                                updateState.minutes = "00";
                            }
                        } else if (value === "" || (CommonValidation.numberOnly(value) && value >= 0 && value <= maxHours) && pageType === 'ip') {
                            updateState.hours = value;
                            if (value === maxHours.toString()) {
                                updateState.minutes = "00";
                            }
                        }
                        break;
                    case 'minutes':
                        const hourVal = parseInt(popupValues?.hours || 0);
                        if (value === "" ||
                            (CommonValidation.numberOnly(value) && value >= 0 && value <= 59 && hourVal < 24 && pageType === 'op')
                        ) {
                            updateState.minutes = value;
                        } else if (value === "" ||
                            (CommonValidation.numberOnly(value) && value >= 0 && value <= maxMinutes && hourVal < maxHours && pageType === 'ip')
                        ) {
                            updateState.minutes = value;
                        }
                        break;
                }
                return { ...prev, ...updateState };
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const convertTimeToDecimal = (time) => {
        try {
            let [hours, minutes] = time?.split(':')?.map(Number);
            return hours * 60 + minutes;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const CalculateHourAmount = (ratePerHour, changedTime, fixedTime, minTime, minAmount) => {
        let fixedTimes = convertTimeToDecimal(fixedTime);
        let changedTimes = convertTimeToDecimal(changedTime);
        let minTimes = convertTimeToDecimal(minTime ? minTime : '00:00');

        let changeAndFixedTime = changedTimes - fixedTimes;
        let time = changeAndFixedTime > 0 ? changeAndFixedTime : 0;

        let timeCalculateTime = (minTimes === 0) ? 0 : Math.ceil(time / minTimes);

        let totalCost = (+ratePerHour) + (timeCalculateTime * (minAmount ? minAmount : 0));

        return totalCost;
    };

    const onSavePopupHandler = (type) => {
        try {
            setformState((prev) => {
                let updates = { ...prev.service_data };

                switch (type) {
                    case 'rate':
                        let total = 0;
                        if (popupValues.unit_type === 'Nos') {
                            total = popupValues.rate_per_unit * popupValues.unit
                        } else {
                            let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                            let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)
                            total = hourTotal
                        }
                        let concession = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(total)
                        updates.rate_per_unit = +CommonValidation.formatAmount(popupValues.rate_per_unit)
                        updates.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, popupValues.old_doctor_amt)
                        updates.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, popupValues.old_hospital_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concession)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concession, total)
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concession, total)
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'concession':
                        let concessionAmt = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.new_doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.new_hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(popupValues.total_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concessionAmt)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concessionAmt, popupValues.total_amt)
                        updates.doc_discount_amt = +CommonValidation.formatAmount(popupValues.doc_discount_amt)
                        updates.doc_discount_percent = +popupValues.doc_discount_percent
                        updates.hos_discount_amt = +CommonValidation.formatAmount(popupValues.hos_discount_amt)
                        updates.hos_discount_percent = +popupValues.hos_discount_percent
                        updates.concession_comments = popupValues.concession_comments
                        if (isMandatoryConcessionRemarksEnabled()) {
                            updates.individual_concession_comments = concessionAmt > 0 ? (popupValues.individual_concession_comments || '') : ''
                        }
                        if (isLineItemRemarksEnabled()) {
                            updates.line_item_remarks = clampLineItemRemarks(popupValues.line_item_remarks || '')
                        }
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concessionAmt, popupValues.total_amt)
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'time':
                        let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                        let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)

                        updates.total_amt = hourTotal
                        updates.unit = Hours.split(":")[0] + ":" + Hours.split(":")[1]
                        updates.old_time_taken = popupValues.old_time_taken
                        updates.interval_amount = popupValues.interval_amount
                        updates.interval_time = popupValues.interval_time
                        updates.rate_per_unit = popupValues.rate_per_unit
                        updates.old_doctor_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal)
                        updates.old_hospital_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal)
                        let docDisc = CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, updates.old_doctor_amt)
                        let hosDis = CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, updates.old_hospital_amt)
                        updates.doc_discount_amt = +docDisc
                        updates.hos_discount_amt = +hosDis
                        updates.new_doctor_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal) || 0) - (+docDisc || 0)
                        updates.new_hospital_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal) || 0) - (+hosDis || 0)
                        updates.concession_amt = updates.doctor_amt && updates.hospital_amt ? (+docDisc) + (+hosDis) : CommonValidation.getDiscountAmountWithRound(popupValues.concession_percent, hourTotal)
                        break;
                }

                return { ...prev, service_data: updates };
            });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const InlineSavePopupHandler = (rowIndex = null) => {
        try {
            setformState(prev => {
                const updatedOrderList = [...prev.orderList];

                const formattedHours = popupValues?.hours?.toString()?.padStart(2, "0") || "00";
                const formattedMinutes = popupValues?.minutes?.toString()?.padStart(2, "0") || "00";
                const Hours = `${formattedHours}:${formattedMinutes}:00`;

                const ratePerUnit = popupValues?.rate_per_unit || 0;
                const oldTimeTaken = popupValues?.old_time_taken || "00:00";
                const intervalTime = popupValues?.interval_time || "00:00";
                const intervalAmount = popupValues?.interval_amount || 0;

                const hourTotal = CalculateHourAmount(ratePerUnit, Hours, oldTimeTaken, intervalTime, intervalAmount);

                const doctorPercent = updatedOrderList[rowIndex]?.doctor_percent || 0;
                const hospitalPercent = updatedOrderList[rowIndex]?.hospital_percent || 0;

                const doctorAmount = ((hourTotal * doctorPercent) / 100);
                const hospitalAmount = ((hourTotal * hospitalPercent) / 100);

                updatedOrderList[rowIndex] = {
                    ...updatedOrderList[rowIndex],
                    total_amount: (hourTotal * (1 + (popupValues?.gst_percent || 0) / 100)),
                    sub_total_amount: hourTotal,
                    unit: `${formattedHours}:${formattedMinutes}`,
                    old_time_taken: oldTimeTaken,
                    interval_amount: intervalAmount,
                    interval_time: intervalTime,
                    rate_per_unit: ratePerUnit,
                    start_date: popupValues?.start_date,
                    end_date: popupValues?.end_date,
                    doctor_amt: doctorAmount,
                    hospital_amt: hospitalAmount,
                    isEditing: false
                };

                return {
                    ...prev,
                    orderList: updatedOrderList
                };
            });

        } catch (error) {
            errorMessage(error.message);
        }
    };

    function getTimeDifference(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        start.setSeconds(0, 0);
        end.setSeconds(0, 0);

        let diff = end - start;

        const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
        diff %= (1000 * 60 * 60);

        const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, '0');

        return `${hours}:${minutes}`;
    }

    const onChangeTimeHandler = useCallback((time, key) => {
        try {
            if (!time) return;

            if (key === 'startDate') {
                if (!popupValues?.end_date) {
                    setPopupValues(prev => ({
                        ...prev,
                        start_date: time
                    }));
                } else {
                    const timeDiff = getTimeDifference(time, popupValues.end_date);
                    setPopupValues(prev => ({
                        ...prev,
                        start_date: time,
                        hours: timeDiff?.split(':')[0],
                        minutes: timeDiff?.split(':')[1],
                    }));
                }
            }

            if (key === 'endDate') {
                if (!popupValues.start_date) {
                    errorMessage('Select Start Date');
                    return;
                }

                const timeDiff = getTimeDifference(popupValues.start_date, time);
                setPopupValues(prev => ({
                    ...prev,
                    end_date: time,
                    hours: timeDiff?.split(':')[0],
                    minutes: timeDiff?.split(':')[1],
                }));
            }
        } catch (error) {
            errorMessage(error.message);
        }
    }, [popupValues]);

    const TimePopup = () => {
        let totalAmt = +popupValues.doctor_amt + (+popupValues.hospital_amt)
        const appointmentDate = formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date());
        const currentDate = dayjs();
        const startDate = dayjs(popupValues?.start_date);
        return (
            <>{openPopup === 'rate' ?
                <Dialog open={openPopup === 'rate'} maxWidth='sm' fullWidth>
                    <Box className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Update Rate Per Unit</Typography>
                            <IconButton
                                onClick={() => setOpenPopup(null)}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                            <Box component={'div'} display={'flex'} justifyContent={'space-evenly'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Rate / Unit - ${popupValues?.rate_per_unit ? CommonValidation.formatAmount(popupValues?.rate_per_unit) : '0'}`}</Typography>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Unit - ${popupValues?.unit}`}</Typography>
                            </Box>
                            <Box component={'div'} mt={'1rem'}>
                                <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_amt', popupValues?.doctor_amt, false, 1, `Doctor Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_percent', popupValues?.doctor_percent_w_r, false, 1, 'Doctor Percentage (%)', true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_amt', popupValues?.hospital_amt, false, 1, `Hospital Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_percent', popupValues?.hospital_percent_w_r, false, 1, `Hospital Percentage (%)`, true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Total Amount</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_amt', totalAmt ? CommonValidation.formatAmount(totalAmt) : '', false, 1, `Total Amount (${CurrencySymbol})`, true)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_percent', '100.00', false, 1, `Total Percentage (%)`, true)}
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box m={'1rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => setOpenPopup(null)}
                            >Close</Button>
                            <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => {
                                    onSavePopupHandler('rate')
                                    setOpenPopup(null)
                                }}
                            >Save</Button>
                        </Box>
                    </Box>
                </Dialog> :
                openPopup === 'concession' ?
                    <Dialog open={openPopup === 'concession'} maxWidth='sm' fullWidth>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Concession</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                                    <Typography fontSize={'1rem'} fontWeight={600}>{`Bill Amount : ${CommonValidation.formatAmount(popupValues?.total_amt)}`}</Typography>
                                </Box>
                                <Box component={'div'} mt={'1rem'}>
                                    <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_amt', popupValues?.doc_discount_amt, false, 1, `Amount (${CurrencySymbol})`, (popupValues?.is_hospital || formState?.service_data?.membership_discount_percentage))}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_percent', popupValues?.doc_discount_percent_w_r, false, 1, 'Percentage (%)', (popupValues?.is_hospital || formState?.service_data?.membership_discount_percentage))}
                                        </Grid>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_amt', popupValues?.hos_discount_amt, false, 1, `Amount (${CurrencySymbol})`, formState?.service_data?.membership_discount_percentage)}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_percent', popupValues?.hos_discount_percent_w_r, false, 1, 'Percentage (%)', formState?.service_data?.membership_discount_percentage)}
                                        </Grid>
                                    </Grid>
                                </Box>
                                {popupValues?.is_hospital ? <Box><FormHelperText sx={{ color: 'red', fontSize: COMMON_STYLES.FONT_SIZE_SM, textAlign: 'center' }}>Concession Enable Only For Hospital !</FormHelperText></Box> : null}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '0.5rem' }}>
                                    <Box>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Doctor Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_doctor_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.doc_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_doctor_amt) || 0}`}</Typography>
                                    </Box>
                                    <Box mr={'2rem'}>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Hosptial Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_hospital_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.hos_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_hospital_amt) || 0}`}</Typography>
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'} display={'flex'} flexDirection={'column'} gap={'0.5rem'}>
                                    {isLineItemRemarksEnabled() ?
                                        popupTextBox('line_item_remarks', popupValues?.line_item_remarks, true, 3, 'Line Item Remarks', formState?.service_data?.membership_discount_percentage, '37dvw')
                                        : null}
                                    {isMandatoryConcessionRemarksEnabled() ? (() => {
                                        const concessionApplied = ((+popupValues?.doc_discount_amt || 0) + (+popupValues?.hos_discount_amt || 0) + (+popupValues?.concession_amt || 0)) > 0;
                                        return popupTextBox('individual_concession_comments', concessionApplied ? popupValues?.individual_concession_comments : '', true, 3, 'Concession Remarks *', (formState?.service_data?.membership_discount_percentage || !concessionApplied), '37dvw');
                                    })() : null}
                                    {(!isMandatoryConcessionRemarksEnabled() && !isLineItemRemarksEnabled()) ?
                                        popupTextBox('concession_comments', popupValues?.concession_comments, true, 3, 'Concession Comments', formState?.service_data?.membership_discount_percentage, '37dvw')
                                        : null}
                                </Box>
                            </Box>
                            <Box m={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    onClick={() => setOpenPopup(null)}
                                >Close</Button>
                                <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    disabled={formState?.service_data?.membership_discount_percentage || (isMandatoryConcessionRemarksEnabled() && (((+popupValues?.doc_discount_amt || 0) + (+popupValues?.hos_discount_amt || 0) + (+popupValues?.concession_amt || 0)) > 0) && !((popupValues?.individual_concession_comments || '').trim()))}
                                    onClick={() => {
                                        onSavePopupHandler('concession')
                                        setOpenPopup(null)
                                    }}
                                >Save</Button>
                            </Box>
                        </Box>
                    </Dialog> :
                    <Dialog open={openPopup === 'time'} maxWidth='sm'>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Unit</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'flex-end'}>
                                    <RadioGroup row
                                        value={selectedRadio}
                                        onChange={(e) => { setSelectedRadio(e.target.value) }}
                                    >
                                        <FormControlLabel value={'input'} control={<Radio size='small' />} label="Based on Input" />
                                        <FormControlLabel value={'time'} control={<Radio size='small' />} label="Based on Time" />
                                    </RadioGroup>
                                </Box>
                                <Box component={'div'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Input</Typography>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                                        <TextField size='small' disabled={selectedRadio === 'time'}
                                            value={popupValues?.hours}
                                            onChange={(e) => { onPopupChangeHandler(e, 'hours') }}
                                            label='Hours'
                                            sx={{ width: '15dvw' }}
                                        />
                                        <TextField size='small' disabled={selectedRadio === 'time'}
                                            value={popupValues?.minutes}
                                            onChange={(e) => { onPopupChangeHandler(e, 'minutes') }}
                                            label='Minutes'
                                            sx={{ width: '15dvw', ml: '1rem' }}
                                        />
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Time</Typography>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                disabled={selectedRadio === 'input'}
                                                value={popupValues?.start_date}
                                                name={"datePicker"}
                                                open={formState.startTimeOpen}
                                                onOpen={() => { setformState((prev) => ({ ...prev, startTimeOpen: true })) }}
                                                onClose={() => { setformState((prev) => ({ ...prev, startTimeOpen: false })) }}
                                                inputFormat='DD-MM-YYYY hh:mm A'
                                                label={('Start Date & Time')}
                                                minDateTime={appointmentDate}
                                                maxDateTime={currentDate}
                                                onChange={(newDate) => { onChangeTimeHandler(newDate, 'startDate') }}
                                                renderInput={(params) => <TextField
                                                    onClick={() => { setformState((prev) => ({ ...prev, startTimeOpen: true })) }}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    size='small' {...params} sx={{ width: '15dvw' }}
                                                />}
                                            />
                                        </LocalizationProvider>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                disabled={selectedRadio === 'input'}
                                                value={popupValues?.end_date}
                                                name={"datePicker"}
                                                open={formState.endTimeOpen}
                                                onOpen={() => { setformState((prev) => ({ ...prev, endTimeOpen: true })) }}
                                                onClose={() => { setformState((prev) => ({ ...prev, endTimeOpen: false })) }}
                                                inputFormat='DD-MM-YYYY hh:mm A'
                                                label={('End Date & Time')}
                                                minDateTime={startDate}
                                                onChange={(newDate) => { onChangeTimeHandler(newDate, 'endDate') }}
                                                renderInput={(params) => <TextField
                                                    onClick={() => { setformState((prev) => ({ ...prev, endTimeOpen: true })) }}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    sx={{ ml: '1rem', width: '15dvw' }}
                                                    size='small' {...params}
                                                />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                                        <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                            onClick={() => setOpenPopup(null)}
                                        >Close</Button>
                                        <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                            onClick={() => {
                                                onSavePopupHandler('time')
                                                setOpenPopup(null)
                                            }}
                                        >Add</Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Dialog>
            }</>
        )
    }

    const onOpenPopupHandler = (type) => {
        setOpenPopup(type)
        setPopupValues((prev) => {
            let popupUpdates = {};
            switch (type) {
                case 'rate':
                    popupUpdates.doctor_amt = formState?.service_data?.old_doctor_amt
                    popupUpdates.doctor_percent = formState?.service_data?.doctor_percent
                    popupUpdates.doctor_percent_w_r = formState?.service_data?.doctor_percent_w_r
                    popupUpdates.hospital_amt = formState?.service_data?.old_hospital_amt
                    popupUpdates.hospital_percent = formState?.service_data?.hospital_percent
                    popupUpdates.hospital_percent_w_r = formState?.service_data?.hospital_percent_w_r
                    popupUpdates.total_amt = formState?.service_data?.total_amt
                    popupUpdates.rate_per_unit = formState.service_data.unit_type === 'Nos' ? formState?.service_data?.total_amt / formState?.service_data?.unit :
                        formState.service_data.rate_per_unit
                    popupUpdates.unit = formState?.service_data?.unit
                    break
                case 'concession':
                    popupUpdates.old_doctor_amt = formState?.service_data?.old_doctor_amt
                    popupUpdates.old_hospital_amt = formState?.service_data?.old_hospital_amt
                    popupUpdates.new_doctor_amt = formState?.service_data?.new_doctor_amt
                    popupUpdates.new_hospital_amt = formState?.service_data?.new_hospital_amt
                    popupUpdates.doctor_amt = formState?.service_data?.doctor_amt
                    popupUpdates.hospital_amt = formState?.service_data?.hospital_amt
                    popupUpdates.total_amt = formState?.service_data?.total_amt
                    popupUpdates.rate_per_unit = formState?.service_data?.rate_per_unit
                    break;
                case 'time':
                    let hours = formState?.service_data?.unit?.toString()?.split(":")[0] || ''
                    let mins = formState?.service_data?.unit?.toString()?.split(":")[1] || ''

                    popupUpdates.hours = hours
                    popupUpdates.minutes = mins
                    popupUpdates.start_date = formState?.service_data?.start_date
                    popupUpdates.end_date = formState?.service_data?.end_date;
                    popupUpdates.interval_amount = formState?.service_data?.interval_amount
                    popupUpdates.interval_time = formState?.service_data?.interval_time
                    popupUpdates.old_time_taken = formState?.service_data?.fixed_time
                    popupUpdates.rate_per_unit = formState?.service_data?.rate_per_unit
                    popupUpdates.total_amount = formState?.service_data?.total_amount
                    popupUpdates.sub_total_amount = formState?.service_data?.sub_total_amount
                    popupUpdates.unit = formState?.service_data?.unit
                    popupUpdates.gst_percent = formState?.service_data?.gst_percent
                    break;
            }
            return {
                ...prev,
                ...popupUpdates,
                concession_amt: formState?.service_data?.concession_amt,
                concession_percent: formState?.service_data?.concession_percent,
                concession_percent_w_r: formState?.service_data?.concession_percent_w_r,
                concession_comments: formState?.service_data?.concession_comments,
                individual_concession_comments: formState?.service_data?.individual_concession_comments || '',
                line_item_remarks: formState?.service_data?.line_item_remarks || formState?.service_data?.remarks || '',
                doc_discount_amt: formState?.service_data?.doc_discount_amt,
                doc_discount_percent: formState?.service_data?.doc_discount_percent,
                doc_discount_percent_w_r: formState?.service_data?.doc_discount_percent_w_r,
                hos_discount_amt: formState?.service_data?.hos_discount_amt,
                hos_discount_percent: formState?.service_data?.hos_discount_percent,
                hos_discount_percent_w_r: formState?.service_data?.hos_discount_percent_w_r,
                doctor_percent: formState?.service_data?.doctor_percent,
                doctor_percent_w_r: formState?.service_data?.doctor_percent_w_r,
                hospital_percent: formState?.service_data?.hospital_percent,
                hospital_percent_w_r: formState?.service_data?.hospital_percent_w_r,
                unit_type: formState?.service_data?.unit_type,
                is_hospital: formState?.service_data?.is_hospital,
                service_head_id: formState?.service_data?.service_head_id,
                op_order_number: formState?.service_data?.op_order_number,
                old_time_taken: formState?.service_data?.old_time_taken
            }
        })
    }

    const InlineTimePopup = (data, index) => {
        setOpenPopup(true)
        setformState((prev) => ({ ...prev, selectedIndex: index }))
        setPopupValues((prev) => {
            let popupUpdates = {};

            let hours = data?.unit?.toString()?.split(":")[0] || ''
            let mins = data?.unit?.toString()?.split(":")[1] || ''

            popupUpdates.hours = hours
            popupUpdates.minutes = mins
            popupUpdates.start_date = formState?.fromOrderSummary ? data?.start_time ? dayjs(data?.start_time) : formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()) : data?.start_date;
            popupUpdates.end_date = formState?.fromOrderSummary ? data?.end_time ? dayjs(data?.end_time) : null : data?.end_date;
            popupUpdates.interval_amount = data?.interval_amount
            popupUpdates.interval_time = data?.interval_time
            popupUpdates.old_time_taken = formState?.fromOrderSummary ? data?.service_unit : data?.fixed_time
            popupUpdates.rate_per_unit = data?.rate_per_unit
            popupUpdates.total_amount = data?.total_amount
            popupUpdates.sub_total_amount = data?.sub_total_amount
            popupUpdates.unit = data?.unit
            popupUpdates.gst_percent = data?.gst_percent

            return {
                ...prev,
                ...popupUpdates
            }
        })
    }

    const onClickUnitHandler = useCallback((type) => {
        try {
            setformState((prev) => {
                const updatedServiceData = { ...prev.service_data };
                switch (type) {
                    case 'increase':
                        updatedServiceData.unit++;
                        break;
                    case 'decrease':
                        updatedServiceData.unit = Math.max(0, updatedServiceData.unit - 1); // Prevent negative units
                        break;
                }
                if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt || updatedServiceData?.is_sharable) {
                    const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                    const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                    const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                    const conTlt = (+disDoc) + (+disHos)

                    updatedServiceData.total_amt = baseTotalAmt
                    updatedServiceData.old_doctor_amt = updatedOldDoc
                    updatedServiceData.old_hospital_amt = updatedOldHos
                    updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doc_discount_amt = disDoc
                    updatedServiceData.hos_discount_amt = disHos
                    updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                    updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                    updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                } else {
                    let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                    updatedServiceData.total_amt = total;
                    updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                }

                return { ...prev, service_data: updatedServiceData };
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [formState.service_data])

    const onUnitInputChange = useCallback((inputValue, previousUnit) => {
        try {
            const allowEmpty = inputValue === '';
            const parsed = parseInt(inputValue, 10);
            const isInvalidNumber = isNaN(parsed) && !allowEmpty;
            if (allowEmpty) {
                setformState((prev) => ({ ...prev, service_data: { ...prev.service_data, unit: '' } }));
                return;
            }
            if (isInvalidNumber) return;
            if (parsed > 9999) {
                const keepPrevious = previousUnit >= 1 && previousUnit <= 9999;
                const effectiveUnit = keepPrevious ? previousUnit : 9999;
                setformState((prev) => {
                    const updatedServiceData = { ...prev.service_data, unit: effectiveUnit };
                    if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt || updatedServiceData?.is_sharable) {
                        const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                        const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                        const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                        const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                        const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                        const conTlt = (+disDoc) + (+disHos)
                        updatedServiceData.total_amt = baseTotalAmt
                        updatedServiceData.old_doctor_amt = updatedOldDoc
                        updatedServiceData.old_hospital_amt = updatedOldHos
                        updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                        updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                        updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                        updatedServiceData.hospital_amt = updatedOldHos - disHos
                        updatedServiceData.doc_discount_amt = disDoc
                        updatedServiceData.hos_discount_amt = disHos
                        updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                        updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                        updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                    } else {
                        let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                        updatedServiceData.total_amt = total;
                        updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                    }
                    return { ...prev, service_data: updatedServiceData };
                });
                return;
            }
            const clampedUnit = Math.max(1, Math.floor(parsed));
            setformState((prev) => {
                const updatedServiceData = { ...prev.service_data, unit: clampedUnit };
                if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt || updatedServiceData?.is_sharable) {
                    const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                    const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                    const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                    const conTlt = (+disDoc) + (+disHos)

                    updatedServiceData.total_amt = baseTotalAmt
                    updatedServiceData.old_doctor_amt = updatedOldDoc
                    updatedServiceData.old_hospital_amt = updatedOldHos
                    updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doc_discount_amt = disDoc
                    updatedServiceData.hos_discount_amt = disHos
                    updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                    updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                    updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                } else {
                    let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                    updatedServiceData.total_amt = total;
                    updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                }
                return { ...prev, service_data: updatedServiceData };
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [])

    const onClearServiceData = (is_from) => {
        try {
            setformState((prev) => ({
                ...prev,
                selected_service: null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                    edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '', doctor_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, doctor_id: '', op_order_number: '',
                    id: null, fromOrderSummary : false,
                },
                isEdit: false,
                selectedIndex: null,
                orderList: is_from === 'clear' ? [] : prev.orderList
            }))
            setIsWarning(false)
            setDuplicateIds([])
            settempDup([])
            if (is_from === 'clear') {
                setserviceDate(new Date())
                setdateOpen(false)
                setDateTimeChanged(false)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onAddHandler = (overrideServiceData) => {
        try {
            let { selected_bill_doc, selectedward } = formState || {};
            let service_data = overrideServiceData || formState?.service_data;
            let { unit_type, total_amount = 0, gst_percent = 0, unit = 0, rate_per_unit = 0 } = service_data || {};

            if (
                !overrideServiceData &&
                isMandatoryConcessionRemarksEnabled() &&
                (+service_data?.concession_amt || 0) > 0 &&
                !((service_data?.individual_concession_comments || '').trim())
            ) {
                setConcessionRemarksOpen(true);
                return;
            }

            let discountTotal = (+service_data.total_amt || 0) - (+service_data.concession_amt || 0)
            let incGst = loggedInUserInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, service_data.gst_percent) : 0
            let tltGstdiff = loggedInUserInfo?.is_gst_enabled ? incGst - discountTotal : 0
            let sgstCgst = loggedInUserInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0
            let service_list = {
                ...service_data,
                total_with_discount: discountTotal,
                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                taxable_amount: discountTotal,
                sub_total_amount: service_data.total_amt,
                concession_applicable: service_data?.edit_discount ? (service_data?.is_hospital ? service_data?.new_hospital_amt : discountTotal) : 0,
                module_type: service_data.module_type,
                unit: (service_data?.unit === '' || service_data?.unit == null || service_data?.unit < 1) ? 1 : service_data?.unit,
                service_head_id: service_data?.service_head_id,
                doctor_id: formState.selected_bill_doc?.doctor_id || formState.selected_bill_doc_id,
                doctor_name: formState.selected_bill_doc?.doctor_name || formState.selected_bill_doc,
                id: service_data?.id ? service_data?.id : null,
                package_detail_id: service_data?.package_detail_id ? service_data?.package_detail_id : null,
                package_name: service_data?.package_name ? service_data?.package_name : '',
                ward_name: selectedward?.ward_name || null,
                ward_id: selectedward?.id || null,
                individual_concession_comments: (+service_data?.concession_amt || 0) > 0 ? (service_data?.individual_concession_comments || '') : '',
            };

            let isDuplicate = false;

            setformState((prev) => {
                const orderList = [...prev.orderList];

                if (!prev.isEdit && orderList.find((item, index) => (index !== formState.selectedIndex && item?.service_details_id === service_list?.service_details_id && item?.doctor_id === service_list?.doctor_id))) {
                    isDuplicate = true;
                    errorMessage("Service already exists in the order.");
                    return prev;
                }
                if (prev.isEdit) {
                    orderList[prev.selectedIndex] = service_list;
                } else {
                    orderList.push(service_list);
                }
                return { ...prev, orderList, dupOrderList: JSON.stringify(orderList) };
            });
            if (!isDuplicate) {
                setTimeout(() => onClearServiceData(), 50);
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const fetchCorporateServices = (corporateData) => {
        try {
            let corporateList = [];
            let data = [corporateData];
            data?.forEach((element) => {
                let total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount
                let totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount
                corporateList?.push({
                    rate_per_unit: element.service_charge,
                    unit: element.unit,
                    unit_type: element.unit_type,
                    total_amt: totalAmt || 0,
                    total_with_discount: total_with_discount || 0,
                    doctor_amt: element.doctor_share_amount,
                    doctor_percent: element.doctor_share_percent,
                    old_doctor_amt: element.doctor_share_amount,
                    new_doctor_amt: element.doctor_share_amount,
                    hospital_amt: element.hospital_share_amount,
                    hospital_percent: element.hospital_share_percent,
                    old_hospital_amt: element.hospital_share_amount,
                    new_hospital_amt: element.hospital_share_amount,
                    interval_time: element.interval_time,
                    interval_amount: element.interval_amount,
                    service_name: element.service_name,
                    service_head_name: element.service_head,
                    service_code: element.service_code,
                    service_head_code: element.service_head_code,
                    edit_unit: element.edit_unit,
                    edit_amount: element.edit_amount,
                    edit_discount: element.edit_discount,
                    doctor_name: (element.doctor_name || formState?.patientData?.doctor_name),
                    doctor_id: (element.doctor_id || formState?.patientData?.doctor_id),
                    start_time: element.start_time,
                    end_time: element.end_time,
                    gst_percent: element.gst_percent || 0,
                    hours: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[0] : '',
                    minutes: element.unit_type === 'Hrs' ? element.unit?.toString()?.split(":")[1] : '',
                    service_details_id: element?.service_details_id,
                    doctor_id: element?.doctor_id,
                    review_days: element?.review_days,
                    review_count: element?.review_count,
                    charge_id: element?.charge_id || element?.service_charge_id,
                    module_type: element?.module_type,
                    doctor_percent_w_r: +(element?.doctor_share_percent?.toFixed(2)),
                    hospital_percent_w_r: +(element?.hospital_share_percent?.toFixed(2)),
                    start_date: formState?.patientData?.appointment_date ? dayjs(formState?.patientData?.appointment_date) : formState?.patientData?.admission_date ? dayjs(formState?.patientData?.admission_date) : dayjs(new Date()),
                    end_date: null,
                    is_hospital: element?.is_hospital,
                    service_head_id: element?.service_head_id,
                    op_order_number: element?.op_order_number,
                    old_time_taken: element.unit_type === 'Hrs' ? element?.unit : null,
                    doc_discount_amt: '',
                    doc_discount_percent: '',
                    doc_discount_percent_w_r: '',
                    hos_discount_amt: '',
                    hos_discount_percent: '',
                    hos_discount_percent_w_r: '',
                    is_sharable: element?.is_sharable,
                    is_consultation: element?.is_consultation
                })
            })
            const duplicateServices = formState.orderList?.filter(orderItem =>
                corporateList.some(newItem => orderItem.service_details_id === newItem.service_details_id && orderItem.doctor_id === newItem.doctor_id)
            );


            if (duplicateServices.length > 0) {
                setIsLoader(false);
                settempDup(corporateList);
                setIsWarning(true);

                setDuplicateIds(duplicateServices.map(item => ({
                    service_details_id: item.service_details_id,
                    doctor_id: item.doctor_id
                })));

                return;
            }

            setformState((prev) => ({ ...prev, orderList: [...formState.orderList, ...corporateList] }))
        }
        catch (error) { }
    }

    const netAmount = useMemo(() => {
        return formState?.orderList?.reduce(
            (acc, item) => acc + Number(item?.total_with_discount || 0),
            0
        );
    }, [formState.orderList]);

    /** One order-line body for BILLING_ORDER_LIST / _IP when updating from order summary (matches bulk save shape). */
    const buildFromSummaryLineUpdateBody = (item) => {
        const patientData = formState.patientData;
        return {
            id: patientData?.appointment_id ? item?.op_order_line_id : item?.ip_order_line_id,
            unit: item?.unit,
            rate_per_unit: +item?.rate_per_unit || 0,
            total_amount: +item?.total_with_discount || +item?.total_amount || 0,
            sub_total_amount: +item?.sub_total_amount || 0,
            doctor_share_percent: +item.doctor_percent || +item.doctor_share_percent || 0,
            hospital_share_percent: +item.hospital_percent || +item.hospital_share_percent || 0,
            old_doctor_fee: +item.old_doctor_amt || +item.old_doctor_fee || 0,
            old_hospital_fee: +item.old_hospital_amt || +item.old_hospital_fee || 0,
            new_doctor_fee: +item.new_doctor_amt || +item.new_doctor_fee || 0,
            new_hospital_fee: +item.new_hospital_amt || +item.new_hospital_fee || 0,
            discount_amount: +item?.concession_amt || +item?.discount_amount || 0,
            discount_percentage: +item?.concession_percent || +item?.discount_percentage || 0,
            start_time: item.start_date ? dayjs(item.start_date).format("YYYY-MM-DD HH:mm:ss") : null,
            end_time: item.end_date ? dayjs(item.end_date).format("YYYY-MM-DD HH:mm:ss") : null,
            service_old_unit_count: item?.unit_type === 'Hrs' ? item?.old_time_taken : null,
            order_date: dayjs(serviceDate).format('YYYY-MM-DD HH:mm:ss'),
            remarks: clampLineItemRemarks(
                item?.line_item_remarks != null ? String(item.line_item_remarks) : (item?.remarks != null ? String(item.remarks) : '')
            ),
            individual_concession_comments: (+item?.concession_amt || +item?.discount_amount || 0) > 0 ? (item?.individual_concession_comments || '') : '',
        };
    };

    const postOrderSummaryLineRemarks = (row, index, text) => {
        const v = clampLineItemRemarks(text != null ? String(text) : '');
        const merged = { ...row, line_item_remarks: v, remarks: v };
        const lineId = formState.patientData?.appointment_id ? merged?.op_order_line_id : merged?.ip_order_line_id;
        if (!lineId) {
            errorMessage('Unable to update remarks: missing order line id.');
            return;
        }
        const body = [buildFromSummaryLineUpdateBody(merged)];
        const apiUrl = formState.patientData?.appointment_id ? Serviceurls.BILLING_ORDER_LIST : Serviceurls.BILLING_ORDER_LIST_IP;
        setIsLoader(true);
        RestAPIService.create(body, apiUrl)
            .then((response) => {
                setIsLoader(false);
                if (response.data.status === 'success') {
                    successMessage(response.data.message);
                    setformState((prev) => {
                        const orderList = [...prev.orderList];
                        orderList[index] = { ...orderList[index], line_item_remarks: v, remarks: v };
                        return { ...prev, orderList };
                    });
                    getOrderCardAmt();
                } else {
                    errorMessage(response.data?.message || 'Update failed');
                }
            })
            .catch((e) => {
                setIsLoader(false);
                errorMessage(e?.response?.data?.message || e.message);
            });
    };

    const postOrderDetails = () => {
        try {
            if (formState.orderList?.length === 0) {
                errorMessage("The Order List Is Empty. Please Add Services.");
                return;
            }
            if (formState?.fromOrderSummary && formState.patientData?.id && !formState.patientData?.appointment_id) {
                // From Order Summary (IP case)
                const hasNonIPService = dupOrdersummary.some(
                    item => item.module_type !== "IP" && item.module_type !== "IP_OP"
                );

                if (hasNonIPService) {
                    const selectedDate = dayjs(serviceDate);
                    const originalOrderDate = dayjs(orderDate);

                    // Compare both date AND time by specifying the unit
                    if (!selectedDate.isSame(originalOrderDate, 'minute')) {
                        errorMessage("Non-IP service is included in this order. Order date and time cannot be changed.");
                        return;
                    }
                }
            } else {
                // New order case
                const hasNonIPService = formState.orderList.some(
                    item => item.module_type !== "IP" && item.module_type !== "IP_OP"
                );

                if (hasNonIPService) {
                    const selectedDate = dayjs(serviceDate);
                    const today = dayjs();

                    // Compare both date AND time by specifying the unit
                    if (!selectedDate.isSame(today, 'minute')) {
                        errorMessage("For non-IP service, order date must be today and time also current time.");
                        return;
                    }
                }else{
                    // Only IP or IP_OP services
                    const admissionDate = formState.patientData?.admission_date
                        ? dayjs(formState.patientData.admission_date)
                        : null;

                    if (admissionDate && dayjs(serviceDate).isBefore(admissionDate)) {
                        errorMessage("For IP/IP-OP service, order date and time cannot be earlier than the admission date and time.");
                        return;
                    }
                }
            }
            let data = {}
            let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
            if (formState?.fromOrderSummary) {
                data = formState.orderList.map((item) => buildFromSummaryLineUpdateBody(item));
            } else {
                data = {
                    patient_id: formState.patientData.patient_id,
                    // doctor_id: formState.selected_bill_doc?.doctor_id,
                    doctor_id: formState.patientData?.doctor_id,
                    order_date: dayjs(serviceDate).format('YYYY-MM-DD HH:mm:ss'),
                    order_status: 'Pending',
                    order_amount: formState?.orderList?.reduce((acc, item) => acc + item.total_with_discount, 0) || 0,
                    ordered_from: LoggedData?.module_name === "Doctor" ? 'DOCTOR' : 'FO',
                    is_direct_bill: false,
                    order_line_items: formState.orderList.map(item => ({
                        bill_doctor_id: item.doctor_id,
                        service_head_id: item.service_head_id,
                        service_details_id: item.service_details_id,
                        service_charge_id: item.charge_id,
                        order_line_status: (formState?.patientData?.id && (item.module_type === 'IP' || item.module_type === 'IP_OP')) ? 'Accepted' : 'Pending',
                        gst_percent: item.gst_percent || 0,
                        unit: item.unit,
                        unit_type: item.unit_type || 'Nos',
                        interval_time: item.interval_time,
                        interval_amount: +item.interval_amount || 0,
                        service_old_unit_count: item?.unit_type === 'Hrs' ? item?.old_time_taken : null,
                        doctor_share_percent: +item.doctor_percent || 0,
                        hospital_share_percent: +item.hospital_percent || 0,
                        old_doctor_fee: +item.old_doctor_amt || 0,
                        old_hospital_fee: +item.old_hospital_amt || 0,
                        new_doctor_fee: +item.new_doctor_amt || 0,
                        new_hospital_fee: +item.new_hospital_amt || 0,
                        start_time: item.start_date ? dayjs(item.start_date).format("YYYY-MM-DD HH:mm:ss") : null,
                        end_time: item.end_date ? dayjs(item.end_date).format("YYYY-MM-DD HH:mm:ss") : null,
                        total_amount: +item?.total_with_discount || 0,
                        sub_total_amount: +item?.sub_total_amount || 0,
                        rate_per_unit: +item?.rate_per_unit || 0,
                        approved_date: null,
                        cancel_date: null,
                        is_active: true,
                        service_code: item.service_code,
                        service_head_code: item.service_head_code,
                        service_head_name: item.service_head_name,
                        service_name: item.service_name,
                        is_sharable: item?.is_sharable,
                        is_consultation: item?.is_consultation || false,
                        billing_display: item?.billing_display,
                        module_type: item?.module_type ?? (patientData?.appointment_id ? 'OP' : 'IP'),
                        drug_config_id: item?.drug_config_id ?? null,
                        discount_amount: +item?.concession_amt || 0,
                        discount_percentage: +item?.concession_percent || 0,
                        drug_ms_id: item?.drug_ms_id ?? null,
                        pharmacy_id: item?.pharmacy_id ?? null,
                        sub_location_id: item?.sub_location_id ?? null,
                        is_membership_discount_applied: item?.membership_discount_percentage ?? false,
                        ...(formState?.patientData?.id ? {
                            is_processed: false
                        } : null),
                        ...(item.ward_id ? {
                            ward_id: item.ward_id,
                            ward_name: item.ward_name,
                        } : null),
                        ...(item.package_id ? {
                            package_detail_id: item.package_id,
                            package_name: item.package_name,
                        } : null),
                        ...(item?.assorted_id ? {
                            assorted_package_id: item?.assorted_package_id,
                            assorted_package_head_id: item?.assorted_head_id,
                            assorted_package_item_id: item?.assorted_id,
                            assorted_package_name: item?.assorted_name
                        } : null),
                        remarks: clampLineItemRemarks(item?.line_item_remarks != null ? String(item.line_item_remarks) : ''),
                        individual_concession_comments: (+item?.concession_amt || 0) > 0 ? (item?.individual_concession_comments || '') : '',
                    })),
                    ...(formState.patientData.appointment_id
                        ? { appointment_id: formState.patientData.appointment_id }
                        : { ip_admission_id: formState.patientData.id }
                    ),
                    surgery_request_id: formState.surgeryId ?? null
                };
            }
            setIsLoader(true);
            const { patientData, fromOrderSummary } = formState;

            let apiUrl = patientData?.appointment_id
                ? (fromOrderSummary ? Serviceurls.BILLING_ORDER_LIST : Serviceurls.BILLING_CREATE_ORDER)
                : (patientData?.id ? (fromOrderSummary ? Serviceurls.BILLING_ORDER_LIST_IP : Serviceurls.BILLING_CREATE_ORDER_IP) : null);

            RestAPIService.create(data, apiUrl)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message);
                        setformState((prev) => ({ ...prev, orderList: [], dupOrderList: '[]', fromOrderSummary: false }));
                        setIsLoader(false);
                        setserviceDate(new Date());
                        setdateOpen(false);
                        setDateTimeChanged(false);
                        getOrderCardAmt();
                    }
                }).catch(e => {
                    setIsLoader(false);
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                });
        } catch (e) {
            setIsLoader(false);
            errorMessage(e.message);
        }
    }

    const CommonPatientSection = ({ PatientData }) => {
        let attender = {
            lineOne: "AttenderName",
            lineTwo: PatientData?.attender_name || "-",
            lineFour: "ContactNumber",
            lineFive: PatientData?.attender_mobile || "-",
        };

        const createOrderAmtCard = (label, amount) => ({
            image: ImagePaths.OrderIcon.default,
            height: "1.3vw",
            width: "1.3vw",
            lineOne: label,
            lineTwo: amount ? AmountFormat(amount) : `${CurrencySymbol} 0.00`,
        });

        return (
            <Box display={'flex'} alignItems='center'>
                <Box className="eMed_Patient_Details_Long eMed_patient_box">
                    <CommonPatientDetails data={PatientData} showDetailed={true} forceOpen={insuToolOpen} />
                </Box>
                {formState.patientData?.appointment_id ? null : <CommonPatientCard details={attender} showDetailed={true} />}
                {showPaymentStatusColumn ? <Box sx={{ display: 'flex', width: opOrder ? "56dvw" : "43.7dvw", alignItems: 'center', overflow: 'auto' }}>
                    {
                        amtState?.map((item, index) => (
                            <CommonPatientCard key={index} details={createOrderAmtCard((item?.module), item?.amount)} smallWidth={true} />
                        ))
                    }
                </Box> : null}
            </Box>
        );
    };
    const isDuplicateRow = (row) => {
        return duplicateIds.some(
            dup => {
                if (dup.service_details_id) {
                    return dup.service_details_id === row.service_details_id && dup.doctor_id === row.doctor_id
                } else if (dup?.assorted_package_id) {
                    return dup.assorted_package_id === row.assorted_package_id && dup.doctor_id === row.doctor_id
                } else if (dup?.package_id) {
                    return dup.package_id === row.package_id && dup.doctor_id === row.doctor_id
                }

                return false
            }
        );
    };

    useEffect(() => {
        if (formState.orderList?.length > 0) {
            let hasDuplicate = hasDuplicateEntries(formState.orderList)
            setHasDuplicate(hasDuplicate)
            updateDuplicateCount()
        }
    }, [formState.orderList])

    const [duplicateCount, setDuplicateCount] = useState({});

    const updateDuplicateCount = (items = formState.orderList) => {
    const count = {};
    
    items.forEach(({ package_id, package_detail_id, drug_config_id, service_details_id, service_charge_id, doctor_id, drug_ms_id, service_head_name }) => {
        const baseKey = drug_ms_id ? `${drug_ms_id}-${doctor_id}` : 
                       drug_config_id ? `${drug_config_id}-${doctor_id}` : 
                       package_detail_id ? `${package_detail_id}-${doctor_id}` : 
                       `${service_details_id || service_charge_id}-${doctor_id}`;
                       
        const compositeKey = `${baseKey}-${service_head_name}`;
        count[compositeKey] = (count[compositeKey] || 0) + 1;  
    });
    setDuplicateCount(count);
};

    const withOutShareHandler = useCallback((e, key) => {
        try {
            const value = e.target.value
            setformState((prev) => {
                const update = { ...prev.service_data };
                switch (key) {
                    case 'rate_per_unit':
                        let Hours = (update?.hours === "" ? "00" : (update?.hours)?.toString()?.length < 2 ? ("0" + update?.hours) : update?.hours) + ":" + (update?.minutes === "" ? "00" : (update?.minutes)?.toString()?.length < 2 ? ("0" + update?.minutes) : update?.minutes) + ":" + "00"
                        let hourTotal = update.unit_type === 'Hrs' ? CalculateHourAmount(value, Hours, update.old_time_taken, update?.interval_time, update?.interval_amount) : 0
                        const newRatePerUnit = update.unit_type === 'Hrs' ? value : (value * update.unit)

                        update.rate_per_unit = value;
                        update.total_amt = update.unit_type === 'Hrs' ? hourTotal : (value * update.unit);
                        update.concession_amt = newRatePerUnit ? +CommonValidation.getDiscountAmountWithRound(update.concession_percent, newRatePerUnit) : ''
                        update.concession_percent = value ? update.concession_percent : ''
                        update.concession_percent_w_r = value ? update.concession_percent_w_r : ''
                        if (!update.concession_amt || +update.concession_amt <= 0) {
                            update.individual_concession_comments = ''
                        }
                        break;
                    case 'concession_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= update.total_amt || value === '') {
                            update.concession_amt = value
                            update.concession_percent = value ? +CommonValidation.getDiscountPercentage(value, update.total_amt) : ''
                            update.concession_percent_w_r = value ? +CommonValidation.getDiscountPercentageWithRound(value, update.total_amt) : ''
                            if (!value || +value <= 0) {
                                update.individual_concession_comments = ''
                            }
                        }
                        break;
                    case 'concession_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= 100 || value === '') {
                            update.concession_percent = value
                            update.concession_percent_w_r = value
                            update.concession_amt = +CommonValidation.getDiscountAmountWithRound(value, update.total_amt)
                            if (!value || +value <= 0) {
                                update.individual_concession_comments = ''
                            }
                        }
                        break;
                    default: break;
                }
                return { ...prev, service_data: update }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [formState?.service_data])

    const renderTable = () => {
        try {
            return (
                <Box sx={{ height: "58vh", width: "100%", mt: "1vw" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: 'flex-end', alignItems: 'flex-end', padding: "0.65vw", backgroundColor: "white", m: "0.75vw" }}>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: (formState.patientData?.id && !formState.patientData?.appointment_id) ? 'space-between' : 'flex-end', alignItems: 'center', width: '100%' }}>
                            {(formState.patientData?.id && !formState.patientData?.appointment_id) ? <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={serviceDate}
                                    name={"datePicker"}
                                    open={dateOpen}
                                    onOpen={() => { setdateOpen(true); }}
                                    onClose={() => { setdateOpen(false); }}
                                    inputFormat='DD-MM-YYYY hh:mm A'
                                    label={('Start Date & Time')}
                                    minDateTime={
                                        formState.patientData?.admission_date
                                            ? dayjs(formState.patientData.admission_date)
                                            : undefined
                                    }
                                    maxDateTime={
                                        formState.patientData?.discharge_date
                                            ? dayjs(formState.patientData.discharge_date).endOf('day')
                                            : dayjs().endOf("day")
                                    }
                                    onChange={(newDate) => {  setserviceDate(newDate); setDateTimeChanged(true); }}
                                    renderInput={(params) => <TextField
                                        onClick={() => { setdateOpen(true); }}
                                        // onKeyDown={(e) => { e.preventDefault() }}
                                        size='small' {...params} sx={{ width: '15dvw' }}
                                    />}
                                />
                            </LocalizationProvider> : null}
                            <Box sx={{ display:"flex", flexDirection:"row",}}>
                                {membershipDetails?.is_memberships ? <IconButton sx={{ height: '1.5vw', width: '1.5vw', marginRight: '0.5vw' }} onClick={() => {
                                    {
                                        setAnchorEl(true);
                                        setDialogOpen(true);
                                    }
                                }}>
                                    <Tooltip title="Membership Details" placement="top">
                                        <img src={ImagePaths.MemberShip.default} alt='help' style={{ height: '1.3vw', width: '1.3vw', marginBottom: '0.4vw' }} />
                                    </Tooltip>
                                </IconButton> : null}
                                <Autocomplete
                                    size='small'
                                    sx={{ width: "20dvw", mr: "0.3vw", mb: "0.3vw", mt: "-1.5vw", ml: "0.3vw" }}
                                    options={formState.tempPackSugg}
                                    disabled={!formState?.patientData?.doctor_id || formState?.fromOrderSummary || ((conditionData?.is_ip_appointment || conditionData?.ip_request_status === "accepted") && !isOPBilling)}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name ? `${option.template_name}` : option?.package_name ? `${option?.package_name ?? ""}` : `${option?.assorted_package_name ?? ""}`}
                                    value={formState.selected_temp_pack}
                                    renderOption={(props, option) => (
                                        <Box component="li"
                                            {...props}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-start",
                                                width: "100%",
                                                textAlign: "left",
                                            }}
                                        >
                                            <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                                                {`${option?.template_name || option?.package_name || option?.assorted_package_name || "-"}${(option?.assorted_package_amount || option?.assorted_package_amount === 0 || option?.package_amount || option?.package_amount === 0) ? ` - ${AmountFormat(option?.assorted_package_amount || option?.package_amount || 0)}` : ""}`}
                                            </Typography>
                                            <Typography
                                                fontSize=".8vw"
                                                fontWeight="bold"
                                                sx={{ width: "100%", textAlign: "left" }}
                                                color={option?.template_name ? "#29B6F6"
                                                    : option?.package_name ? "#1E972A"
                                                        : option?.assorted_package_name ? "blue"
                                                            : "inherit"}
                                            >
                                                {option?.template_name ? "Template"
                                                    : option?.package_name ? "Package"
                                                        : option?.assorted_package_name ? 'Assorted'
                                                            : ""}
                                            </Typography>
                                        </Box>
                                    )}
                                    onChange={(e, newValue) => { getTemplateData(newValue) }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label={formState?.patientData?.appointment_id ? 'Search Template/Package' : 'Search Package'}
                                        variant='standard'
                                        disabled={!formState?.patientData?.doctor_id || formState?.fromOrderSummary}
                                        InputProps={{ ...params.InputProps, emed_tid: 'ser_temp_pack' }}
                                    />}
                                />
                            </Box>
                            {formState?.employeerID && formState?.patientData?.appointment_id && formState.corporatesugg.length > 0 ?
                                <Autocomplete
                                    size='small'
                                    sx={{ width: "20dvw", mr: "0.3vw", mb: "0.3vw", mt: "-1.5vw" }}
                                    options={formState.corporatesugg}
                                    disabled={formState?.fromOrderSummary || ((conditionData?.is_ip_appointment || conditionData?.ip_request_status === "accepted") && !isOPBilling)}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`}
                                    value={formState.selected_corporate_data}
                                    onChange={(e, newValue) => { fetchCorporateServices(newValue) }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label='Search Corporate Services'
                                        variant='standard'
                                        InputProps={{ ...params.InputProps, emed_tid: 'ser_temp_pack' }}
                                    />}
                                /> : null}
                        </Box>
                        <TableContainer sx={{ height: '45dvh', overflow: 'auto', border: '1px solid lightgray' }}>
                            <Table stickyHeader>
                                <TableHead size="small" sx={{ "& .MuiTableCell-root": { padding: "0.25rem" } }}>
                                    <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                                        <TableCell sx={{ fontSize: '0.9rem', width: "4%", fontWeight: 600, backgroundColor: '#F5F8F7' }}>S.No</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', width: "11%", fontWeight: 600, backgroundColor: '#F5F8F7' }}>Doctor Name</TableCell>
                                        {formState?.patientData?.id ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7' }}>Ward Name</TableCell> : null}
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, width: "31%", backgroundColor: '#F5F8F7' }}>Service Description</TableCell>
                                        <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, width: "8%", backgroundColor: '#F5F8F7' }}>Module</TableCell>
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7' }}>Rate Per Unit</TableCell> : null}
                                        <TableCell sx={{ fontSize: '0.9rem', width: "8%", fontWeight: 600, backgroundColor: '#F5F8F7' }}>Unit</TableCell>
                                        {/* {formState?.is_gst_enabled && AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', fontWeight: 600, backgroundColor: '#F5F8F7', }}>GST</TableCell> : null} */}
                                        {AmountViewAccess && ConcessionAccess ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7', }}>Concession</TableCell> : null}
                                        {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem', width: "10%", fontWeight: 600, backgroundColor: '#F5F8F7', }}>Total Amount</TableCell> : null}
                                        {userAccess?.editAccess && <TableCell sx={{ fontSize: '0.9rem', width: "8%", fontWeight: 600, backgroundColor: '#F5F8F7', width: "6%" }}>Action</TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody size="small" sx={{ "& .MuiTableCell-root": { padding: '1px' } }}>
                                    {formState?.orderList?.length > 0 ? formState?.orderList?.map((row, index) => {
                                        const tempTotal = row?.unit_type !== 'Hrs' ? (row.tempUnit * row.tempRate) + ((row.tempUnit * row.tempRate * (row.gst_percent || 0)) / 100) : null;
                                        let docName = formState?.fromOrderSummary ? (row?.bill_doctor_name || '') : (row?.doctor_name || '');
                                        let dupli = isDuplicateRow(row)
                                        const key = row?.drug_ms_id ? `${row?.drug_ms_id}-${row.doctor_id}` : row?.drug_config_id ? `${row?.drug_config_id}-${row.doctor_id}` : row?.package_detail_id ? `${row?.package_detail_id}-${row.doctor_id}` : `${row.service_details_id || row?.service_charge_id}-${row.doctor_id}`;
                                        const serviceHeadKey = `${key}-${row?.service_head_name}`;
                                        const isDuplicate = duplicateCount[serviceHeadKey] > 1;
                                        return (
                                            <TableRow key={index} sx={{ backgroundColor: isDuplicate ? '#d2f7f1' : 'white' }}>
                                                <TableCell style={{ fontSize: '0.9rem', paddingLeft: "0.5vw" }}>{index + 1}</TableCell>
                                                <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    <div style={{ fontSize: '0.9rem', paddingLeft: "0.5vw" }}>{(() => {
                                                        const text = `${docName}` || '-';
                                                        return text.length > 20 ? (
                                                            <Tooltip title={text}>
                                                                <span>{text.slice(0, 18) + '...'}</span>
                                                            </Tooltip>
                                                        ) : (text);
                                                    })()}</div>
                                                </TableCell>
                                                {formState?.patientData?.id ? <TableCell sx={{ fontSize: '0.9rem' }}>{(() => {
                                                    const text = `${row?.ward_name}` || '-';
                                                    return text.length > 18 ? (
                                                        <Tooltip title={text}>
                                                            <span>{text.slice(0, 16) + '...'}</span>
                                                        </Tooltip>
                                                    ) : (text);
                                                })()}</TableCell> : null}
                                                <TableCell sx={{ fontSize: '0.9rem', paddingRight: "5px" }}>{(() => {
                                                    const text = `${row?.service_head_name} - ${row?.service_name}` || '-';
                                                    return text.length > 120 ? (
                                                        <Tooltip title={text}>
                                                            <span>{text.slice(0, 115) + '...'}</span>
                                                        </Tooltip>
                                                    ) : (text);
                                                })()}</TableCell>
                                                <TableCell sx={{ fontSize: '0.9rem' }}>{(row?.module_type === 'IP_OP' ? 'IP & OP' : row?.module_type) || '-'}</TableCell>
                                                {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}>{CommonValidation.formatAmount(row?.rate_per_unit) || '-'}</TableCell> : null}
                                                <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    <div style={{ fontSize: '0.9rem', paddingLeft: "0.5vw" }}>{row?.unit_type === 'Hrs' ? ((row?.unit?.toString()?.split(':').slice(0, 2).join(':')) || '-') : (row?.unit || '-')}</div>
                                                </TableCell>
                                                {AmountViewAccess && ConcessionAccess ? <TableCell sx={{ fontSize: '0.9rem' }}> {CommonValidation.formatAmount(row?.concession_amt || 0)}</TableCell> : null}
                                                {AmountViewAccess ? <TableCell sx={{ fontSize: '0.9rem' }}>
                                                    {row?.isEditing && row?.unit_type !== 'Hrs' ? CommonValidation.formatAmount(tempTotal) : row?.total_with_discount ? CommonValidation.formatAmount(row?.total_with_discount) : '0'}
                                                </TableCell> : null}
                                                {userAccess?.editAccess && <TableCell sx={{ fontSize: '0.9rem', width: "6%" }}>
                                                    <Box sx={{ display: "flex" }}>
                                                        <div style={{ marginTop: '0.25vw' }}>
                                                            {(() => {
                                                                const lineOn = isLineItemRemarksEnabled();
                                                                const concOn = isMandatoryConcessionRemarksEnabled();
                                                                const rowHasConcession = (+row?.concession_amt || 0) > 0;
                                                                const concessionEmpty = concOn && rowHasConcession && !((row?.individual_concession_comments || '').trim());
                                                                const mode = lineOn && concOn ? 'both' : (lineOn ? 'line' : 'concession');
                                                                const tooltip = mode === 'both' ? 'Line Item / Concession Remarks'
                                                                    : (mode === 'line' ? undefined : 'Concession Remarks');
                                                                const dlgTitle = mode === 'both' ? 'Line Item & Concession Remarks'
                                                                    : (mode === 'line' ? undefined : 'Concession Remarks');
                                                                return (
                                                                    <LineItemRemarksButton
                                                                        enabled={lineOn || concOn}
                                                                        readOnly={!userAccess?.editAccess || !!formState?.patientData?.is_final_bill_initiated}
                                                                        value={mode === 'concession'
                                                                            ? (rowHasConcession ? (row.individual_concession_comments || '') : '')
                                                                            : (row.line_item_remarks || row.remarks || '')}
                                                                        warning={concessionEmpty}
                                                                        title={tooltip}
                                                                        dialogTitle={dlgTitle}
                                                                        fieldLabel={mode === 'concession' ? 'Concession Remarks' : 'Line Item Remarks'}
                                                                        required={mode === 'concession' && rowHasConcession}
                                                                        secondField={mode === 'both' ? {
                                                                            label: 'Concession Remarks',
                                                                            placeholder: 'Enter remarks for concession',
                                                                            value: rowHasConcession ? (row.individual_concession_comments || '') : '',
                                                                            required: rowHasConcession,
                                                                        } : undefined}
                                                                        onSave={(primary, second) => {
                                                                            const pv = clampLineItemRemarks(primary);
                                                                            if (mode === 'concession') {
                                                                                setformState((prev) => {
                                                                                    const orderList = [...prev.orderList];
                                                                                    orderList[index] = { ...orderList[index], individual_concession_comments: pv };
                                                                                    return { ...prev, orderList };
                                                                                });
                                                                                return;
                                                                            }
                                                                            if (mode === 'line') {
                                                                                setformState((prev) => {
                                                                                    const orderList = [...prev.orderList];
                                                                                    orderList[index] = { ...orderList[index], line_item_remarks: pv, remarks: pv };
                                                                                    return { ...prev, orderList };
                                                                                });
                                                                                return;
                                                                            }
                                                                            const sv = clampLineItemRemarks(second || '');
                                                                            setformState((prev) => {
                                                                                const orderList = [...prev.orderList];
                                                                                orderList[index] = {
                                                                                    ...orderList[index],
                                                                                    line_item_remarks: pv,
                                                                                    remarks: pv,
                                                                                    individual_concession_comments: sv,
                                                                                };
                                                                                return { ...prev, orderList };
                                                                            });
                                                                        }}
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                        <Box visibility={(row?.package_id || row?.assorted_id || row?.package_detail_id || row?.assorted_package_id || row?.is_advance_adjusted) ? "hidden" : "visible"}>
                                                            <CommonEditButton onClick={() => {
                                                                setformState((prev) => ({
                                                                    ...prev,
                                                                    service_data: row,
                                                                    selected_service: row,
                                                                    isEdit: true,
                                                                    selectedIndex: index
                                                                }));
                                                            }} />
                                                        </Box>
                                                        <CommonDeleteButton onClick={() => {
                                                            if (formState?.fromOrderSummary) {
                                                                setformState((prev) => ({
                                                                    ...prev,
                                                                    openDeletePopup: true,
                                                                    deleted_service: formState?.patientData?.appointment_id ? row?.op_order_line_id : row?.ip_order_line_id,
                                                                    deleted_data: row,
                                                                    deleted_service_index: index
                                                                }));
                                                            } else {
                                                                let selectedLine = row
                                                                setformState((prev) => {
                                                                    const updatedOrderList = prev.orderList.filter((_, i) => {
                                                                        // if (_?.assorted_package_id || _?.package_package_id) {
                                                                        //     return (_?.assorted_package_id !== selectedLine?.assorted_package_id) || (_?.package_package_id !== selectedLine?.package_package_id)
                                                                        // } else {
                                                                        return i !== index
                                                                        // }
                                                                    });

                                                                    const remainingDuplicates = updatedOrderList.filter(orderItem =>
                                                                        duplicateIds.some(dup =>
                                                                            dup.service_details_id === orderItem.service_details_id &&
                                                                            dup.doctor_id === orderItem.doctor_id
                                                                        )
                                                                    );

                                                                    const newDuplicateIds = duplicateIds.filter(dup =>
                                                                        remainingDuplicates.filter(item =>
                                                                            item.service_details_id === dup.service_details_id &&
                                                                            item.doctor_id === dup.doctor_id
                                                                        ).length > 1
                                                                    );

                                                                    setDuplicateIds(newDuplicateIds);

                                                                    return { ...prev, orderList: updatedOrderList };
                                                                });
                                                            }
                                                        }} />
                                                    </Box>
                                                </TableCell>}
                                            </TableRow>
                                        );
                                    }) : <TableRow>
                                        <TableCell colSpan={9} align='center'
                                            sx={{ borderBottom: 'none', position: 'relative', top: '10rem' }}
                                        >No Records To Be Shown</TableCell>
                                    </TableRow>}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box component={'div'} mt={'0.5rem'} display={'flex'} justifyContent={'space-around'} alignItems={'center'}
                            ref={billingContainerRef}
                            id="data-billing-container"
                            tabIndex={0}
                            sx={{
                                width: "100%",
                                outline: 'none',
                                '&:focus-visible': { outline: 'none' },
                            }}
                        >
                            <Autocomplete
                                disabled={Object.keys(formState.patientData)?.length === 0 || formState?.fromOrderSummary || formState?.patientData?.is_final_bill_initiated || !formState?.patientData?.doctor_id}
                                size='small'
                                sx={{ width: '15dvw' }}
                                options={formState.billDocSugg}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                                value={formState.selected_bill_doc}
                                onChange={(e, newValue) => {
                                    setformState((prev) => ({
                                        ...prev, selected_bill_doc: newValue, selected_service: null,
                                        service_data: {
                                            ...prev.service_data,
                                            edit_unit: '',
                                            rate_per_unit: '',
                                            total_amount: '',
                                            unit: 1, unit_type: 'Nos',
                                        },
                                    }))
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label='Bill Doctor'
                                    InputProps={{
                                        ...params.InputProps, emed_tid: 'Bl_doc',
                                    }}
                                />}
                            />

                            {formState?.patientData?.id ?
                                <Autocomplete
                                    size='small'
                                    disabled={Object.keys(formState.patientData)?.length === 0 || formState?.fromOrderSummary || formState?.patientData?.is_final_bill_initiated || !formState?.patientData?.doctor_id}
                                    options={formState?.wardList || []}
                                    getOptionLabel={(option) => option?.ward_name || ''}
                                    sx={{ width: '12dvw' }}
                                    value={formState?.selectedward}
                                    onChange={(event, newValue) => {
                                        setformState((prev) => ({
                                            ...prev,
                                            selectedward: newValue, selected_service: null,
                                            service_data: {
                                                ...prev.service_data,
                                                edit_unit: '',
                                                rate_per_unit: '',
                                                total_amount: '',
                                                unit: 1, unit_type: 'Nos',
                                            },
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='Select Ward'
                                        />
                                    )}
                                /> : null}

                            <Autocomplete
                                size='small'
                                sx={{ width: AmountViewAccess ? '32dvw' : '60dvw' }}
                                options={formState.serviceSugg}
                                disabled={!formState.selected_bill_doc || formState?.fromOrderSummary || (!formState?.selectedward && formState?.patientData?.id) || formState?.patientData?.is_final_bill_initiated || ((conditionData?.is_ip_appointment || conditionData?.ip_request_status === "accepted") && !isOPBilling)}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${(option?.service_head ?? option?.service_head_name) && option?.service_head_code ? `${option?.service_head ?? option?.service_head_name} (${option?.service_head_code})` : option?.service_head ?? option?.service_head_name} - ${option?.service_name && option?.service_code ? `${option?.service_name} (${option?.service_code})` : option?.service_name}`}
                                value={formState.selected_service}
                                onChange={(e, newValue) => { onSelectServiceHandler(newValue); setsearchKey('') }}
                                PopperComponent={CustomPopper}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label='Search Service'
                                    InputProps={{
                                        ...params.InputProps, emed_tid: 'ser_sear',
                                    }}
                                />}
                                onInputChange={(event, newInputValue) => {
                                    if (newInputValue?.length >= 3) {
                                        // Call your API here with the search key
                                        setsearchKey(newInputValue);
                                    }
                                }}
                                componentsProps={{ popper: { style: { width: AmountViewAccess ? '32dvw' : '60dvw' } } }}
                                renderOption={(props, item) => {
                                    let serviceName = `${item?.service_head && item?.service_head_code ? `${item?.service_head} (${item?.service_head_code})` : item?.service_head} `;
                                    let serName = `- ${item?.service_name && item?.service_code ? `${item?.service_name} (${item?.service_code})` : item?.service_name}`;
                                    let displayName = serviceName + serName
                                    let depart = item?.module_type === "IP_OP" ? 'IP & OP' : item?.module_type;

                                    return (
                                        <Box {...props} key={item?.id} sx={{ width: '100%', overflow: 'hidden' }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start", overflow: 'hidden' }}>
                                                <Box sx={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
                                                    {/* display Name */}
                                                    <Tooltip title={displayName} arrow>
                                                        <Typography>
                                                            {displayName.length > 68 ? serviceName.length > 68 ?
                                                                (<span
                                                                    style={{
                                                                        fontSize: "0.9vw",
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >{`${serviceName.slice(0, 65)}...`}</span>) :
                                                                (<><span
                                                                    style={{
                                                                        fontSize: "0.9vw",
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >{serviceName}</span>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "0.9vw",
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >{`${serName.slice(0, (65 - (serviceName.length)))}...`}</span></>) :
                                                                (<><span
                                                                    style={{
                                                                        fontSize: "0.9vw",
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >{serviceName}</span>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "0.9vw",
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >{serName}</span></>)
                                                            }
                                                        </Typography>
                                                    </Tooltip>
                                                </Box>


                                                {/* Department */}
                                                <Tooltip title={depart} arrow>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "0.9vw",
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {depart}
                                                    </Typography>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    );
                                }}

                            />

                            {formState?.service_data?.unit_type === 'Hrs' ?
                                <Box component={'div'}
                                    border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                                    display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
                                    <Button
                                        disabled={!formState?.service_data?.edit_unit || formState?.patientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                                        sx={{ textTransform: 'capitalize' }}
                                        endIcon={<AccessTimeIcon />}
                                        onClick={() => onOpenPopupHandler('time')}
                                    >{`${formState?.service_data?.unit?.length > 5 ? formState?.service_data.unit?.slice(0, 5) : formState?.service_data?.unit}`}</Button>
                                </Box> :
                                <Box component={'div'} border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                                    display={'flex'} alignItems={'stretch'} justifyContent={'space-between'} width={'9dvw'}>
                                    <IconButton
                                        sx={{ height: 'auto', width: '2.5dvw', borderRadius: '5px 0 0 5px' }}
                                        disabled={(formState?.service_data?.unit === '' || +formState?.service_data?.unit <= 1) || !formState?.service_data?.edit_unit || formState?.patientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                                        onClick={() => onClickUnitHandler('decrease')}
                                    ><RemoveIcon color={((formState?.service_data?.unit === '' || +formState?.service_data?.unit <= 1) || !formState?.service_data?.edit_unit || formState?.patientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)) ? 'disabled' : 'primary'} /></IconButton>
                                    <TextField
                                        type="number"
                                        size="small"
                                        variant="standard"
                                        value={formState?.service_data?.unit === '' || formState?.service_data?.unit === undefined ? '' : formState?.service_data?.unit}
                                        onChange={(e) => onUnitInputChange(e.target.value, formState?.service_data?.unit)}
                                        onBlur={(e) => {
                                            const v = e.target.value;
                                            if (v === '' || isNaN(parseInt(v, 10))) onUnitInputChange('1', formState?.service_data?.unit);
                                        }}
                                        disabled={!formState?.service_data?.edit_unit || formState?.patientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                                        inputProps={{ min: 1, max: 9999, inputMode: 'numeric' }}
                                        InputProps={{ disableUnderline: true }}
                                        sx={{
                                            flex: 1,
                                            minWidth: 0,
                                            '& .MuiInputBase-root': { height: '100%', '& input': { textAlign: 'center', fontSize: COMMON_STYLES.FONT_SIZE_L, fontWeight: COMMON_STYLES.FONT_WEIGHT } },
                                            '& input[type=number]': { MozAppearance: 'textfield' },
                                            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 }
                                        }}
                                    />
                                    <IconButton
                                        disabled={!formState?.service_data?.edit_unit || formState?.patientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)}
                                        sx={{ height: 'auto', width: '2.5dvw', borderRadius: '0 5px 5px 0' }}
                                        onClick={() => onClickUnitHandler('increase')}
                                    ><AddIcon color={(!formState?.service_data?.edit_unit || formState?.patientData?.is_final_bill_initiated || InvestigationList?.includes(formState?.service_data?.module_type)) ? 'disabled' : 'primary'} /></IconButton>
                                </Box>}

                            {AmountViewAccess && AmountEditAccess ?
                                (!!formState?.service_data?.doctor_amt || !!formState?.service_data?.hospital_amt || !!formState?.service_data?.is_sharable) ?
                                    <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                                        disabled={!formState?.service_data?.edit_amount}
                                        endIcon={`(${CommonValidation.formatAmount(formState?.service_data?.rate_per_unit)})`}
                                        onClick={() => onOpenPopupHandler('rate')}
                                    >Rate/Unit</Button> :
                                    <TextField
                                        autoComplete='off'
                                        size='small'
                                        InputProps={{ emed_tid: 'rte_unit', readOnly: !formState?.service_data?.edit_amount }}
                                        sx={{ width: '7dvw' }}
                                        label='Rate/Unit'
                                        value={formState?.service_data?.rate_per_unit || ""}
                                        onChange={(e) => { withOutShareHandler(e, 'rate_per_unit') }}
                                    />
                                : null}

                            {AmountViewAccess && ConcessionAccess ?
                                <Box component={'div'} display={'flex'}>
                                    {(!!formState?.service_data?.doctor_amt || !!formState?.service_data?.hospital_amt || !!formState?.service_data?.is_sharable) ?
                                        <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                                            disabled={!formState?.service_data?.edit_discount}
                                            endIcon={`(${CommonValidation.formatAmount(formState?.service_data?.concession_amt)})`}
                                            onClick={() => onOpenPopupHandler('concession')}
                                        >Concession</Button>
                                        :
                                        <><TextField
                                            disabled={!formState?.service_data?.edit_discount || formState?.service_data?.membership_discount_percentage}
                                            autoComplete='off'
                                            size='small'
                                            InputProps={{ emed_tid: 'con_amt' }}
                                            sx={{ width: '7dvw' }}
                                            label={`Concession (${CurrencySymbol})`}
                                            value={+formState?.service_data?.concession_amt ? formState?.service_data?.concession_amt : ""}
                                            onChange={(e) => { withOutShareHandler(e, 'concession_discount_amt') }}
                                        />
                                            <TextField
                                                disabled={!formState?.service_data?.edit_discount || formState?.service_data?.membership_discount_percentage}
                                                autoComplete='off'
                                                size='small'
                                                InputProps={{ emed_tid: 'con_per' }}
                                                sx={{ width: '7dvw' }}
                                                label={`Concession (%)`}
                                                value={+formState?.service_data?.concession_percent_w_r ? formState?.service_data?.concession_percent_w_r : ""}
                                                onChange={(e) => { withOutShareHandler(e, 'concession_discount_percent') }}
                                            /></>}
                                </Box>
                                : null}


                            {AmountViewAccess ? <Box component={'div'}>
                                <TextField
                                    size='small'
                                    sx={{ width: '9dvw' }}
                                    value={formState?.service_data?.total_amt ? CommonValidation.formatAmount((+formState?.service_data?.total_amt) - (+formState?.service_data?.concession_amt || 0)) : ''}
                                    InputProps={{ emed_tid: 'tlt', readOnly: true }}
                                    label='Total'
                                />
                            </Box> : null}

                            {userAccess?.editAccess && <IconButton
                                disabled={(!formState.selected_bill_doc || !formState.selected_service || (formState?.fromOrderSummary && !formState?.isEdit) || !formState?.patientData?.doctor_id || (!formState?.selectedward && formState?.patientData?.id) || formState?.patientData?.is_final_bill_initiated) ? true : false}
                                sx={{ height: '2dvw', width: '2.5dvw' }}
                                onClick={() => {
                                    if (formState.selected_service?.autobilling_type === "yearly") {
                                        setAnnualFeeAlert(true)
                                    } else {
                                        onAddHandler()
                                    }
                                }}
                            ><AddBoxIcon sx={{ height: '3dvw', width: '2.7dvw' }} color={!formState.selected_bill_doc || !formState.selected_service || (formState?.fromOrderSummary && !formState?.isEdit) || !formState?.patientData?.doctor_id || (!formState?.selectedward && formState?.patientData?.id) || formState?.patientData?.is_final_bill_initiated ? 'disabled' : 'primary'} />
                            </IconButton>}
                        </Box>
                    </Box>
                </Box>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            if (ServiceCount && searchKey?.length >= 3) {
                getServiceListData(searchKey);
            } else if (ServiceCount && !searchKey) {
                setformState((prev) => ({ ...prev, serviceSugg: [] }))
            }
        }, 500);
        return () => clearTimeout(handler);
    }, [searchKey, ServiceCount]);

    const popClose = () => {
        setIsWarning(false)
        setAnnualFeeAlert(false)
        settempDup([])
        setDuplicateIds([])
        setAnnualFeeList([])
        setDialogOpen(false)
    }

    const renderConcessionRemarksDialog = () => {
        if (!concessionRemarksOpen) return null;
        const lineOn = isLineItemRemarksEnabled();
        const concOn = isMandatoryConcessionRemarksEnabled();
        const row = formState?.service_data || {};
        const rowHasConcession = (+row?.concession_amt || 0) > 0;
        const mode = lineOn && concOn ? 'both' : (lineOn ? 'line' : 'concession');
        const dlgTitle = mode === 'both' ? 'Line Item & Concession Remarks'
            : (mode === 'line' ? 'Line Item Remarks' : 'Concession Remarks');
        return (
            <LineItemRemarksButton
                enabled={lineOn || concOn}
                hideIcon
                open={concessionRemarksOpen}
                onClose={() => setConcessionRemarksOpen(false)}
                value={mode === 'concession'
                    ? (rowHasConcession ? (row.individual_concession_comments || '') : '')
                    : (row.line_item_remarks || row.remarks || '')}
                dialogTitle={dlgTitle}
                fieldLabel={mode === 'concession' ? 'Concession Remarks' : 'Line Item Remarks'}
                required={mode === 'concession' && rowHasConcession}
                secondField={mode === 'both' ? {
                    label: 'Concession Remarks',
                    placeholder: 'Enter remarks for concession',
                    value: rowHasConcession ? (row.individual_concession_comments || '') : '',
                    required: rowHasConcession,
                } : undefined}
                onSave={(primary, second) => {
                    const pv = clampLineItemRemarks(primary);
                    const next = { ...row };
                    if (mode === 'concession') {
                        next.individual_concession_comments = pv;
                    } else if (mode === 'line') {
                        next.line_item_remarks = pv;
                        next.remarks = pv;
                    } else {
                        const sv = clampLineItemRemarks(second || '');
                        next.line_item_remarks = pv;
                        next.remarks = pv;
                        next.individual_concession_comments = sv;
                    }
                    setformState((prev) => ({ ...prev, service_data: next }));
                    setConcessionRemarksOpen(false);
                    onAddHandler(next);
                }}
            />
        );
    }

    const PopoverBox = () => {
            return(
                <Popover
                    open={dialogOpen}
                    anchorEl={anchorEl}
                    onClose={popClose}
                    anchorReference="anchorPosition" 
                    anchorPosition={{ top: 0, left: 0 }}
                    slotProps={{
                        paper:{
                            sx: { 
                            width: '27vw', 
                            borderRadius: '0.4vw', 
                            padding: '1rem', 
                            boxShadow: '0px 0.2vw 1vw rgba(0,0,0,0.1)',
                            position: 'fixed !important',
                            top: '17vw !important',
                            left: '50vw !important',
                            boxShadow: '0vw 0.4vw 1.5vw rgba(0, 0, 0, 0.15)', 
                            border: '1px solid rgba(0, 0, 0, 0.05)', 
                         }
                        }
                    }} 
                >
                    <Box display='flex' justifyContent='space-between' alignItems='center' mb='0.5rem'>
                        <Typography fontSize='1rem' fontWeight={600}>Membership Card</Typography>
                        {membershipDetails?.membership_expiry_count && (
                            <Box sx={{
                            backgroundColor: '#fee2e2', 
                            color: '#b91c1c', 
                            padding: '2px 12px',
                            borderRadius: '20px',
                            fontSize: '0.75rem',
                            border: '1px solid #fecaca'
                        }}  
                        >
                            {`Expires in ${membershipDetails?.membership_expiry_count} ${Number(membershipDetails?.membership_expiry_count) === 1 ? 'Day' : 'Days'}`}
                        </Box>
                        )}
                    </Box>
                        <Divider sx={{ mb:2 }}/>
                        <Grid container spacing={1.5} sx={{width: '26vw' }}>
                        <Grid item  sx={{ flex: '0 0 30%' }}>
                            <Typography color="textSecondary" fontSize="0.9rem">Package Name</Typography>
                        </Grid>
                        <Grid item xs={8.4}>
                            <Tooltip title={membershipDetails?.membership_type || '-'} arrow placement="top">
                            <Typography fontWeight={600} fontSize="0.9rem">{`: ${membershipDetails?.membership_type ?
                                membershipDetails?.membership_type.length > 25
                                    ? membershipDetails?.membership_type.slice(0, 35) + '...'
                                    : membershipDetails?.membership_type
                                : '-'}`}</Typography>   
                            </Tooltip> 
                        </Grid>
    
                        <Grid item  sx={{ flex: '0 0 30%' }} >
                            <Typography color="textSecondary" fontSize="0.9rem">Validity Period</Typography>
                        </Grid>
                        <Grid item xs={8.4}>
                            <Typography fontWeight={600} fontSize="0.9rem"> { `: ${membershipDetails?.membership_validity || '-'}` } </Typography>
                        </Grid>
                        <Grid item sx={{ flex: '0 0 30%' }}>
                            <Typography color="textSecondary" fontSize="0.9rem">No.of Visit</Typography>
                        </Grid>
                        <Grid item xs={8.4}>
                            <Typography fontWeight={600} fontSize="0.9rem">{`: ${membershipDetails?.membership_no_of_visit || '0'} / ${membershipDetails?.membership_total_no_of_visit || '-'}`}</Typography>
                        </Grid>
                    </Grid>
                </Popover>
            )
        }

    const confirmRemove = () => {
        if (annualFeeList?.length) {
            let serviceList = setAutoBillData(annualFeeList)
            setformState((prev) => ({ ...prev, orderList: [...prev.orderList, ...serviceList?.orderList], surgeryId: serviceList?.surgeryId }));
            setAnnualFeeList([])
        } else if (annualFeeAlert) {
            setAnnualFeeAlert(false)
            onAddHandler()
        } else {
            setIsWarning(false);
            setformState((prev) => ({
                ...prev,
                orderList: [...prev.orderList, ...tempDup],
            }));
        }
    };

    return (
        <Box sx={{ backgroundColor: Colors.ComponentBgColor, height: "74vh" }}>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: 'flex-end', justifyContent: "space-between" }}>
                <Box component={"div"} marginLeft={"0.5vw"} className="eMed_patient_header">
                    <Box display={"flex"} alignItems="center">
                        <CommonPatientSection PatientData={formState?.patientData} />
                    </Box>
                </Box>
                {(formState?.patientData?.id || userAccess?.editAccess === false) ? null : <Button
                    disabled={(conditionData?.is_ip_appointment || conditionData?.ip_request_status === "accepted") && !isOPBilling}
                    variant='contained'
                    onClick={() => {
                        setCachevalue(true, 'isForCancelBill')
                        setCachevalue(true, 'FromOtherScreen')
                        setCachevalue(true, 'FromCreate')
                        setCachevalue('/OPHome/PatientDetails/CreateOrder', 'path')
                        history.push({ pathname: "/HospitalBilling/HospitalBilling", state: { patientId: formState.patientData, appointment_id: formState.patientData?.appointment_id } })
                    }}
                    sx={{ textTransform: "capitalize", width: "8vw", marginTop: "1vw", marginRight: "0.75vw" }}
                    size="small"
                >
                    {"Create Bill"}
                </Button>}
            </Box>
            <Box>{renderTable()}</Box>
            {userAccess?.editAccess &&
                <Box component="div" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginRight: "0.75vw", marginTop: "1.1vw" }}>
                    <Typography sx={{ fontSize: "0.95vw", fontWeight: 800, color: 'red', marginLeft: "2.5vw", textTransform: 'capitalize', display: (!formState?.patientData?.doctor_id || formState?.patientData?.is_final_bill_initiated) ? "block": "none" }}>
                        {!formState?.patientData?.doctor_id ? 'A doctor has not been assigned to this appointment !' : formState?.patientData?.is_final_bill_initiated ? 'The final bill has been generated for this appointment !' : ''}
                    </Typography>
                    <Typography sx={{ fontSize: "0.95vw", fontWeight: 800, display: (formState?.patientData?.doctor_id || !formState?.patientData?.is_final_bill_initiated) ? "block": "none", marginLeft: "0.75vw" }}>
                        Net Amount: {CommonValidation.formatAmount(netAmount)}
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                        <Button
                            variant="outlined"
                            onClick={() => { onClearServiceData("clear") }}
                            sx={{ textTransform: "capitalize", width: "7vw", mr: '0.5vw' }}
                            size="small"
                        >
                            {"Clear"}
                        </Button>
                        <Button
                            // || formState?.orderList.some(item => item?.total_amount == null || isNaN(item?.total_amount))  disabled for 0 service
                            disabled={disableBtn || formState.selected_service || formState.orderList.some(isDuplicateRow) || hasDuplicate || formState?.orderList.some(item => item?.isEditing == true) || (isMandatoryConcessionRemarksEnabled() && formState?.orderList?.some(item => (+item?.concession_amt || 0) > 0 && !((item?.individual_concession_comments || '').trim())))}
                            variant='contained'
                            onClick={() => { setDisableBtn(true) }}
                            sx={{ textTransform: "capitalize", width: "7vw" }}
                            size="small"
                        >
                            {"Order"}
                        </Button>
                    </Box>
                </Box>}
            {renderDeletePopup()}
            {TimePopup()}
            {PopoverBox()}
            {renderConcessionRemarksDialog()}
            <Loader loaderOpen={isLoader} />
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {((conditionData?.is_ip_appointment || conditionData?.ip_request_status === "accepted") && !isOPBilling) && <ToastMsg severity={'error'} msg={"Patient is already admitted as IP. OP billing is not allowed"} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
            {IsWarning ? <ConfirmPopup
                cnfTitle={'Confirmation'}
                cnfContent={"Some services in the template already exist in the order list. Do you want to Continue?"}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
            {annualFeeAlert ? <ConfirmPopup
                cnfTitle={'Annual Fee Confirmation'}
                cnfContent={"This service is configured for annual auto billing, and proceeding will start the annual period from today."}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
            {annualFeeList?.length ? <ConfirmPopup
                cnfTitle={'Annual Fee Confirmation'}
                cnfContent={"Auto billing services include some annual-fee services. Do you still want to proceed ?"}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
        </Box>
    );
};

export default CreateOrder;